var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCkdHomeDesign2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 420,
    viewBox: "0 0 272 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -193,
    y: -42,
    width: 506.049,
    height: 504
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(21px)",
      clipPath: "url(#bgblur_0_218_14601_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.7685 64.2274C81.6626 64.8267 89.1064 68.5536 87.7294 78.6666C86.7834 85.614 83.4438 88.7351 80.3146 91.6595C77.7501 94.0563 75.3269 96.3209 74.4784 100.452C74.3879 96.2365 72.412 93.5761 70.3209 90.7606C67.7694 87.3253 65.0462 83.6589 65.3674 76.6552C65.8347 66.4604 73.8295 64.1222 77.7685 64.2274Z",
    fill: "url(#paint0_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7462 345.146C36.9259 344.186 29.8665 339.78 32.1915 329.84C33.7888 323.012 37.4081 320.217 40.7993 317.598C43.5787 315.451 46.2048 313.423 47.4392 309.39C47.1316 313.595 48.8478 316.428 50.6641 319.426C52.8803 323.085 55.2455 326.99 54.2651 333.932C52.8379 344.038 44.6579 345.619 40.7462 345.146Z",
    fill: "url(#paint1_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.807 73.7803C117.412 75.3622 123.633 80.8794 119.673 90.2931C116.952 96.7601 112.914 98.9147 109.131 100.934C106.031 102.588 103.101 104.151 101.207 107.923C102.216 103.828 101 100.749 99.7119 97.4913C98.1408 93.5157 96.464 89.2729 98.5957 82.5906C101.699 72.8636 110.029 72.6642 113.807 73.7803Z",
    fill: "url(#paint2_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98393 335.592C1.54356 333.68 -4.12941 327.606 0.701523 318.604C4.02028 312.42 8.24324 310.652 12.2001 308.995C15.443 307.638 18.5072 306.355 20.7485 302.777C19.3578 306.76 20.2786 309.938 21.2532 313.303C22.4423 317.407 23.7114 321.788 20.9587 328.242C16.9518 337.636 8.63931 337.056 4.98393 335.592Z",
    fill: "url(#paint3_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.132 92.2188C149.203 94.6754 153.777 101.607 147.503 109.68C143.193 115.226 138.733 116.267 134.554 117.243C131.128 118.042 127.892 118.798 125.082 121.953C127.121 118.257 126.747 114.97 126.35 111.492C125.867 107.247 125.351 102.717 129.148 96.8111C134.675 88.2148 142.773 90.1677 146.132 92.2188Z",
    fill: "url(#paint4_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.0753 317.081C-29.9013 314.348 -33.8012 307.02 -26.7936 299.569C-21.9795 294.45 -17.4406 293.83 -13.1878 293.249C-9.70229 292.773 -6.40889 292.323 -3.31345 289.445C-5.69255 292.933 -5.62979 296.241 -5.56337 299.741C-5.48233 304.012 -5.39584 308.571 -9.73318 314.095C-16.0468 322.137 -23.9253 319.437 -27.0753 317.081Z",
    fill: "url(#paint5_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.541 118.286C174.868 121.45 177.484 129.324 169.324 135.506C163.719 139.752 159.14 139.609 154.849 139.475C151.333 139.366 148.01 139.262 144.475 141.585C147.406 138.541 147.899 135.27 148.421 131.807C149.058 127.583 149.738 123.074 154.941 118.348C162.516 111.468 169.83 115.44 172.541 118.286Z",
    fill: "url(#paint6_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.2466 290.875C-55.2655 287.507 -57.1266 279.424 -48.4199 274.032C-42.4385 270.327 -37.8931 270.898 -33.6341 271.432C-30.1435 271.87 -26.8454 272.284 -23.1068 270.3C-26.3121 273.057 -27.1117 276.268 -27.958 279.667C-28.9905 283.813 -30.0925 288.238 -35.7189 292.458C-43.909 298.6 -50.8166 293.961 -53.2466 290.875Z",
    fill: "url(#paint7_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.234 150.206C192.66 153.862 193.139 162.141 183.649 166.01C177.13 168.669 172.744 167.351 168.635 166.117C165.267 165.105 162.084 164.149 158.065 165.483C161.688 163.297 163.016 160.264 164.42 157.054C166.134 153.138 167.963 148.958 174.219 145.733C183.324 141.038 189.357 146.759 191.234 150.206Z",
    fill: "url(#paint8_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.7463 258.759C-72.8206 254.987 -72.5161 246.7 -62.7035 243.734C-55.9625 241.696 -51.7203 243.418 -47.7454 245.031C-44.4877 246.353 -41.4095 247.602 -37.2824 246.649C-41.0956 248.486 -42.7031 251.382 -44.4043 254.447C-46.4801 258.186 -48.6955 262.177 -55.2276 264.803C-64.736 268.626 -70.2019 262.367 -71.7463 258.759Z",
    fill: "url(#paint9_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.939 185.803C201.365 189.701 199.674 197.821 189.502 199.115C182.513 200.004 178.619 197.602 174.971 195.351C171.981 193.506 169.156 191.763 164.927 192.016C168.995 190.838 171.065 188.25 173.257 185.512C175.931 182.17 178.785 178.603 185.666 177.099C195.683 174.91 200.021 181.99 200.939 185.803Z",
    fill: "url(#paint10_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-81.3138 222.924C-81.3703 219.003 -78.9209 211.077 -68.6713 210.739C-61.6301 210.507 -57.9801 213.262 -54.5602 215.844C-51.7573 217.96 -49.1089 219.96 -44.8747 220.103C-49.0358 220.895 -51.3416 223.278 -53.7819 225.8C-56.7595 228.877 -59.9373 232.161 -66.9299 233.016C-77.1086 234.26 -80.7603 226.806 -81.3138 222.924Z",
    fill: "url(#paint11_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.992 222.652C200.39 226.527 196.645 233.935 186.482 232.564C179.501 231.623 176.365 228.299 173.426 225.185C171.017 222.633 168.742 220.222 164.591 219.378C168.827 219.288 171.5 217.321 174.329 215.24C177.781 212.701 181.466 209.991 188.503 210.311C198.748 210.776 201.098 218.732 200.992 222.652Z",
    fill: "url(#paint12_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-81.2974 185.809C-80.3322 182.008 -75.9048 174.982 -65.9167 177.296C-59.055 178.886 -56.2461 182.487 -53.6142 185.862C-51.4571 188.628 -49.419 191.242 -45.3662 192.47C-49.5916 192.164 -52.4386 193.872 -55.4517 195.679C-59.1281 197.885 -63.0518 200.238 -70.0283 199.263C-80.1837 197.842 -81.7725 189.702 -81.2974 185.809Z",
    fill: "url(#paint13_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.392 258.515C189.803 262.103 184.259 268.294 174.799 264.353C168.3 261.645 166.135 257.627 164.107 253.862C162.444 250.777 160.873 247.862 157.083 245.977C161.198 246.981 164.292 245.77 167.566 244.489C171.561 242.925 175.824 241.257 182.539 243.378C192.314 246.466 192.514 254.756 191.392 258.515Z",
    fill: "url(#paint14_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.696 150.221C-69.7749 146.797 -63.6713 141.152 -54.6253 145.959C-48.4108 149.262 -46.6344 153.464 -44.9698 157.402C-43.6056 160.629 -42.3166 163.679 -38.7214 165.909C-42.7233 164.525 -45.9174 165.441 -49.2979 166.411C-53.4227 167.595 -57.8248 168.857 -64.3099 166.118C-73.7499 162.131 -73.1673 153.859 -71.696 150.221Z",
    fill: "url(#paint15_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.864 290.683C170.396 293.74 163.43 298.291 155.318 292.048C149.745 287.759 148.699 283.32 147.718 279.161C146.915 275.753 146.155 272.532 142.985 269.736C146.698 271.765 150.002 271.393 153.497 270.998C157.763 270.517 162.315 270.003 168.249 273.782C176.888 279.282 174.925 287.341 172.864 290.683Z",
    fill: "url(#paint16_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.0945 118.317C-50.3484 115.505 -42.9845 111.624 -35.497 118.598C-30.3533 123.388 -29.7303 127.905 -29.1466 132.138C-28.6682 135.606 -28.2162 138.884 -25.3236 141.964C-28.8291 139.596 -32.1528 139.659 -35.6703 139.725C-39.9623 139.806 -44.5429 139.892 -50.0946 135.575C-58.1759 129.292 -55.4617 121.452 -53.0945 118.317Z",
    fill: "url(#paint17_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.67 316.964C143.49 319.281 135.578 321.883 129.366 313.763C125.099 308.185 125.242 303.628 125.377 299.358C125.488 295.859 125.592 292.553 123.257 289.035C126.316 291.952 129.603 292.442 133.082 292.962C137.328 293.596 141.858 294.272 146.608 299.45C153.521 306.988 149.53 314.267 146.67 316.964Z",
    fill: "url(#paint18_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.7606 92.2731C-23.3767 90.264 -15.2543 88.412 -9.83568 97.0764C-6.11317 103.029 -6.68619 107.552 -7.2231 111.79C-7.66313 115.264 -8.07892 118.546 -6.08601 122.267C-8.85635 119.077 -12.083 118.281 -15.4979 117.439C-19.6646 116.411 -24.1115 115.315 -28.3514 109.716C-34.5232 101.565 -29.8624 94.6914 -26.7606 92.2731Z",
    fill: "url(#paint19_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.594 335.567C110.921 336.986 102.601 337.462 98.7128 328.019C96.0414 321.531 97.3654 317.167 98.606 313.077C99.6227 309.725 100.583 306.558 99.2428 302.559C101.439 306.164 104.487 307.485 107.712 308.883C111.648 310.589 115.849 312.409 119.089 318.634C123.807 327.695 118.058 333.698 114.594 335.567Z",
    fill: "url(#paint20_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51135 73.8631C9.30244 72.794 17.6298 73.0971 20.6103 82.862C22.6579 89.5702 20.928 93.7919 19.307 97.7475C17.9786 100.989 16.7233 104.053 17.6807 108.16C15.8343 104.365 12.9246 102.765 9.84509 101.072C6.0876 99.0066 2.07745 96.802 -0.561752 90.3016C-4.40352 80.8394 1.88625 75.4 5.51135 73.8631Z",
    fill: "url(#paint21_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8233 345.224C74.906 345.648 66.7465 343.966 65.4464 333.843C64.5533 326.888 66.9673 323.013 69.2293 319.383C71.0831 316.407 72.8347 313.595 72.58 309.387C73.7637 313.435 76.3641 315.496 79.1163 317.677C82.4744 320.338 86.0582 323.178 87.5696 330.026C89.7696 339.994 82.6554 344.311 78.8233 345.224Z",
    fill: "url(#paint22_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5218 64.3419C45.4618 64.2857 53.4265 66.7232 53.7658 76.923C53.9989 83.9301 51.23 87.5623 48.6355 90.9657C46.5091 93.7549 44.5 96.3905 44.3566 100.604C43.56 96.4633 41.1655 94.1686 38.6312 91.7402C35.539 88.777 32.2389 85.6147 31.3802 78.656C30.1304 68.5267 37.6205 64.8927 41.5218 64.3419Z",
    fill: "url(#paint23_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2794 144.991C65.9713 136.396 69.2761 126.149 69.2761 115.148C69.2761 104.146 65.9713 93.8991 60.2794 85.3043C54.5875 93.8991 51.2827 104.146 51.2827 115.148C51.2827 126.149 54.5875 136.396 60.2794 144.991Z",
    fill: "url(#paint24_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2794 324.052C65.9713 315.458 69.2761 305.211 69.2761 294.209C69.2761 283.207 65.9713 272.96 60.2794 264.366C54.5875 272.96 51.2827 283.207 51.2827 294.209C51.2827 305.211 54.5875 315.458 60.2794 324.052Z",
    fill: "url(#paint25_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8029 147.025C83.5363 140.189 89.3936 131.142 92.2549 120.516C95.1162 109.889 94.589 99.1399 91.3264 89.3719C83.5931 96.2079 77.7358 105.254 74.8745 115.881C72.0132 126.508 72.5403 137.257 75.8029 147.025Z",
    fill: "url(#paint26_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2325 319.985C36.9659 313.149 42.8231 304.102 45.6844 293.475C48.5458 282.849 48.0186 272.1 44.756 262.332C37.0227 269.168 31.1654 278.214 28.3041 288.841C25.4427 299.468 25.9699 310.217 29.2325 319.985Z",
    fill: "url(#paint27_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2687 152.988C99.5164 148.377 107.527 141.147 113.055 131.619C118.582 122.091 120.869 111.573 120.258 101.297C111.01 105.909 102.999 113.138 97.4718 122.666C91.9442 132.194 89.6578 142.712 90.2687 152.988Z",
    fill: "url(#paint28_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.3013 308.059C9.54906 303.448 17.5596 296.218 23.0872 286.691C28.6149 277.163 30.9013 266.645 30.2904 256.369C21.0426 260.98 13.0321 268.21 7.50441 277.738C1.97675 287.265 -0.309631 297.784 0.3013 308.059Z",
    fill: "url(#paint29_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.691 162.473C112.823 160.401 122.44 155.481 130.258 147.701C138.075 139.922 143.019 130.351 145.102 120.268C134.97 122.34 125.352 127.26 117.534 135.04C109.717 142.819 104.773 152.39 102.691 162.473Z",
    fill: "url(#paint30_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.5426 289.089C-14.4107 287.016 -4.79279 282.096 3.02452 274.317C10.8418 266.538 15.786 256.966 17.8683 246.884C7.73637 248.956 -1.88152 253.876 -9.69882 261.655C-17.5161 269.435 -22.4603 279.006 -24.5426 289.089Z",
    fill: "url(#paint31_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.222 174.835C122.548 175.443 133.118 173.167 142.692 167.667C152.266 162.166 159.531 154.194 164.165 144.991C153.839 144.383 143.269 146.659 133.695 152.159C124.121 157.66 116.856 165.632 112.222 174.835Z",
    fill: "url(#paint32_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-43.6058 264.365C-33.2802 264.973 -22.7104 262.698 -13.1362 257.197C-3.562 251.696 3.70299 243.725 8.33672 234.522C-1.98894 233.914 -12.5588 236.189 -22.133 241.69C-31.7071 247.191 -38.9721 255.163 -43.6058 264.365Z",
    fill: "url(#paint33_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.214 189.23C128.03 192.477 138.831 193.001 149.51 190.154C160.188 187.307 169.279 181.478 176.148 173.782C166.333 170.535 155.531 170.011 144.853 172.858C134.174 175.706 125.083 181.534 118.214 189.23Z",
    fill: "url(#paint34_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55.5897 235.575C-45.774 238.821 -34.9725 239.346 -24.2939 236.499C-13.6153 233.651 -4.52461 227.822 2.34471 220.127C-7.47096 216.88 -18.2724 216.355 -28.951 219.203C-39.6296 222.05 -48.7203 227.879 -55.5897 235.575Z",
    fill: "url(#paint35_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.258 204.678C128.895 210.343 139.192 213.631 150.247 213.631C161.302 213.631 171.599 210.343 180.236 204.678C171.599 199.014 161.302 195.725 150.247 195.725C139.192 195.725 128.895 199.014 120.258 204.678Z",
    fill: "url(#paint36_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-59.6769 204.678C-51.0401 210.343 -40.7432 213.631 -29.6879 213.631C-18.6326 213.631 -8.33565 210.343 0.301132 204.678C-8.33566 199.014 -18.6326 195.725 -29.6879 195.725C-40.7432 195.725 -51.0401 199.014 -59.6769 204.678Z",
    fill: "url(#paint37_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.214 220.127C125.083 227.822 134.174 233.651 144.853 236.499C155.531 239.346 166.333 238.821 176.148 235.575C169.279 227.879 160.188 222.05 149.51 219.203C138.831 216.355 128.03 216.88 118.214 220.127Z",
    fill: "url(#paint38_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55.5896 173.782C-48.7203 181.478 -39.6296 187.307 -28.9509 190.154C-18.2723 193.002 -7.47092 192.477 2.34474 189.23C-4.52458 181.534 -13.6153 175.706 -24.2939 172.858C-34.9725 170.011 -45.7739 170.535 -55.5896 173.782Z",
    fill: "url(#paint39_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.2 234.567C116.837 243.755 124.103 251.715 133.677 257.211C143.251 262.706 153.818 264.981 164.141 264.379C159.504 255.191 152.238 247.23 142.664 241.735C133.09 236.24 122.523 233.964 112.2 234.567Z",
    fill: "url(#paint40_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-43.6223 145.129C-38.9859 154.317 -31.7195 162.278 -22.1457 167.773C-12.5719 173.268 -2.00414 175.544 8.31825 174.941C3.68184 165.753 -3.58455 157.792 -13.1584 152.297C-22.7322 146.802 -33.2999 144.526 -43.6223 145.129Z",
    fill: "url(#paint41_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.677 246.929C104.765 256.998 109.714 266.559 117.532 274.333C125.351 282.107 134.966 287.027 145.094 289.103C143.005 279.034 138.057 269.473 130.238 261.699C122.42 253.926 112.804 249.006 102.677 246.929Z",
    fill: "url(#paint42_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.5752 120.405C-22.4865 130.474 -17.5381 140.035 -9.71962 147.809C-1.90118 155.582 7.71457 160.502 17.8419 162.579C15.7532 152.51 10.8048 142.949 2.98633 135.175C-4.83209 127.401 -14.4478 122.481 -24.5752 120.405Z",
    fill: "url(#paint43_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2623 256.417C89.6609 266.681 91.9541 277.191 97.4844 286.713C103.015 296.236 111.023 303.465 120.265 308.079C120.867 297.815 118.573 287.306 113.043 277.783C107.513 268.26 99.5044 261.031 90.2623 256.417Z",
    fill: "url(#paint44_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.253281 101.429C-0.348053 111.693 1.94514 122.202 7.47537 131.725C13.0056 141.248 21.0141 148.477 30.2562 153.091C30.8575 142.827 28.5643 132.317 23.0341 122.795C17.5039 113.272 9.49541 106.043 0.253281 101.429Z",
    fill: "url(#paint45_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8035 262.384C72.553 272.144 72.0348 282.886 74.8999 293.508C77.7651 304.131 83.6205 313.176 91.3476 320.014C94.598 310.254 95.1162 299.512 92.2511 288.89C89.386 278.267 83.5305 269.222 75.8035 262.384Z",
    fill: "url(#paint46_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1709 89.494C25.9205 99.2536 25.4023 109.996 28.2674 120.618C31.1325 131.241 36.988 140.286 44.7151 147.124C47.9655 137.364 48.4837 126.622 45.6186 116C42.7535 105.377 36.898 96.3316 29.1709 89.494Z",
    fill: "url(#paint47_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.105 59.9436C57.1568 66.7823 59.6089 72.5815 60.0785 74.6263C63.3866 66.9498 62.5091 70.3181 69.479 58.8162C75.0549 49.6147 73.9237 40.7689 72.6611 37.4962C71.6237 35.0329 68.6237 29.108 64.9235 25.1144C61.2232 21.1208 59.1498 14.4374 58.5756 11.5949C57.7429 18.239 56.0359 22.6173 52.5022 27.0004C49.6752 30.5069 47.522 36.2112 46.7988 38.625C45.7126 42.8818 45.0531 53.1049 51.105 59.9436Z",
    fill: "url(#paint48_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.105 386.432C57.1568 393.271 59.6089 399.07 60.0785 401.115C63.3866 393.438 62.5091 396.807 69.479 385.305C75.0549 376.103 73.9237 367.257 72.6611 363.985C71.6237 361.521 68.6237 355.596 64.9235 351.603C61.2232 347.609 59.1498 340.926 58.5756 338.083C57.7429 344.727 56.0359 349.106 52.5022 353.489C49.6752 356.995 47.522 362.7 46.7988 365.113C45.7126 369.37 45.0531 379.593 51.105 386.432Z",
    fill: "url(#paint49_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5047 62.6398C93.5717 70.8042 94.432 77.0374 94.3538 79.1334C99.5457 72.5706 97.822 75.598 107.546 66.2832C115.325 58.8314 116.533 49.9957 116.164 46.5093C115.803 43.8628 114.446 37.367 111.911 32.5564C109.375 27.7459 109.111 20.7562 109.295 17.8627C106.763 24.0659 103.975 27.8554 99.4222 31.179C95.7796 33.8378 92.2162 38.7932 90.8898 40.9385C88.7335 44.7704 85.4376 54.4754 89.5047 62.6398Z",
    fill: "url(#paint50_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5912 378.003C8.65822 386.168 9.51852 392.401 9.44031 394.497C14.6322 387.934 12.9085 390.962 22.6324 381.647C30.4115 374.195 31.6194 365.359 31.251 361.873C30.8896 359.226 29.5329 352.731 26.9973 347.92C24.4618 343.109 24.1973 336.12 24.3819 333.226C21.8495 339.429 19.062 343.219 14.5087 346.543C10.8661 349.201 7.3027 354.157 5.97633 356.302C3.82002 360.134 0.52417 369.839 4.5912 378.003Z",
    fill: "url(#paint51_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.895 75.1343C127.7 84.068 126.91 90.3104 126.289 92.3149C133.011 87.3129 130.559 89.7932 142.374 83.3003C151.826 78.106 155.291 69.8825 155.841 66.42C156.181 63.7706 156.56 57.1467 155.362 51.847C154.164 46.5473 155.726 39.7277 156.657 36.9803C152.597 42.3199 148.919 45.2623 143.657 47.2999C139.447 48.9299 134.716 52.7986 132.877 54.5292C129.797 57.6752 124.09 66.2006 125.895 75.1343Z",
    fill: "url(#paint52_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38.1454 357.882C-36.3404 366.815 -37.1305 373.058 -37.7512 375.062C-31.0294 370.06 -33.4817 372.541 -21.6666 366.048C-12.2145 360.853 -8.74971 352.63 -8.19884 349.167C-7.8596 346.518 -7.48065 339.894 -8.67863 334.594C-9.87662 329.295 -8.31427 322.475 -7.38335 319.728C-11.4428 325.067 -15.1209 328.01 -20.3834 330.047C-24.5934 331.677 -29.3242 335.546 -31.1634 337.277C-34.2428 340.423 -39.9505 348.948 -38.1454 357.882Z",
    fill: "url(#paint53_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.795 96.5759C157.215 105.67 154.829 111.496 153.708 113.273C161.502 110.172 158.488 111.936 171.589 108.708C182.07 106.125 187.555 99.0742 188.988 95.8716C190.005 93.3998 192.094 87.0993 192.315 81.6716C192.536 76.2439 195.819 70.059 197.432 67.6451C192.123 71.7571 187.805 73.652 182.191 74.2647C177.701 74.7549 172.125 77.2732 169.898 78.4712C166.106 80.7168 158.375 87.4816 157.795 96.5759Z",
    fill: "url(#paint54_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-74.1928 327.438C-74.7728 336.533 -77.1595 342.359 -78.2804 344.135C-70.4866 341.035 -73.5005 342.799 -60.3993 339.57C-49.9184 336.988 -44.4328 329.937 -43.0002 326.734C-41.9835 324.262 -39.8947 317.962 -39.6735 312.534C-39.4523 307.106 -36.1695 300.922 -34.5558 298.508C-39.8656 302.62 -44.1837 304.514 -49.7968 305.127C-54.2873 305.617 -59.8631 308.136 -62.0897 309.334C-65.8824 311.579 -73.6129 318.344 -74.1928 327.438Z",
    fill: "url(#paint55_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.032 125.503C180.107 134.138 176.286 139.151 174.742 140.578C183.076 139.591 179.706 140.519 193.201 140.775C203.996 140.979 211.129 135.581 213.345 132.857C214.97 130.731 218.627 125.183 220.252 119.998C221.877 114.812 226.657 109.683 228.843 107.767C222.645 110.372 217.981 111.09 212.4 110.236C207.935 109.553 201.894 110.549 199.432 111.133C195.184 112.325 185.958 116.868 183.032 125.503Z",
    fill: "url(#paint56_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101.094 288.748C-104.02 297.383 -107.84 302.396 -109.385 303.823C-101.05 302.835 -104.42 303.763 -90.926 304.019C-80.1304 304.224 -72.998 298.826 -70.7812 296.102C-69.1563 293.976 -65.5 288.428 -63.8747 283.242C-62.2494 278.056 -57.4699 272.928 -55.2833 271.012C-61.4817 273.616 -66.1454 274.334 -71.7267 273.48C-76.1917 272.797 -82.2325 273.794 -84.6947 274.377C-88.9423 275.569 -98.1687 280.113 -101.094 288.748Z",
    fill: "url(#paint57_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.886 159.945C194.814 167.532 189.82 171.39 187.957 172.371C196.264 173.564 192.768 173.592 205.736 177.315C216.11 180.293 224.404 176.916 227.253 174.856C229.376 173.221 234.35 168.804 237.269 164.213C240.188 159.623 246.138 155.9 248.749 154.613C242.084 155.532 237.392 155.024 232.223 152.762C228.088 150.952 221.994 150.359 219.464 150.288C215.051 150.346 204.957 152.358 199.886 159.945Z",
    fill: "url(#paint58_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117.016 244.447C-122.088 252.034 -127.082 255.892 -128.945 256.873C-120.638 258.066 -124.134 258.094 -111.166 261.817C-100.792 264.795 -92.4984 261.418 -89.6486 259.357C-87.5261 257.723 -82.5515 253.306 -79.6329 248.715C-76.7143 244.125 -70.7638 240.402 -68.1534 239.114C-74.8179 240.033 -79.5095 239.526 -84.6784 237.263C-88.8136 235.454 -94.9077 234.86 -97.4379 234.79C-101.851 234.847 -111.944 236.859 -117.016 244.447Z",
    fill: "url(#paint59_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.207 197.554C200.335 203.577 194.508 206.017 192.453 206.484C200.167 209.776 196.782 208.903 208.34 215.839C217.587 221.388 226.476 220.262 229.764 219.006C232.24 217.973 238.194 214.988 242.207 211.306C246.22 207.623 252.936 205.56 255.792 204.989C249.116 204.16 244.716 202.461 240.311 198.945C236.788 196.131 231.056 193.989 228.63 193.269C224.353 192.188 214.08 191.532 207.207 197.554Z",
    fill: "url(#paint60_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-120.874 197.554C-127.746 203.577 -133.573 206.017 -135.628 206.484C-127.914 209.777 -131.299 208.903 -119.741 215.839C-110.494 221.388 -101.605 220.262 -98.3167 219.006C-95.8414 217.974 -89.8875 214.988 -85.8744 211.306C-81.8613 207.624 -75.1454 205.56 -72.289 204.989C-78.9655 204.16 -83.3652 202.462 -87.7697 198.945C-91.2932 196.132 -97.0253 193.989 -99.451 193.269C-103.728 192.188 -114.002 191.532 -120.874 197.554Z",
    fill: "url(#paint61_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.498 235.768C196.294 239.815 190.03 240.671 187.924 240.593C194.519 245.76 191.477 244.045 200.837 253.721C208.325 261.463 217.204 262.665 220.707 262.298C223.367 261.938 229.894 260.588 234.728 258.065C239.562 255.542 246.586 255.279 249.494 255.462C243.26 252.942 239.452 250.168 236.112 245.637C233.441 242.012 228.461 238.466 226.305 237.146C222.455 235 212.702 231.72 204.498 235.768Z",
    fill: "url(#paint62_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-112.404 151.267C-120.608 155.314 -126.872 156.17 -128.978 156.092C-122.383 161.259 -125.425 159.543 -116.065 169.22C-108.577 176.961 -99.698 178.163 -96.1946 177.797C-93.5351 177.437 -87.0077 176.087 -82.1736 173.564C-77.3396 171.041 -70.3158 170.777 -67.4082 170.961C-73.6416 168.441 -77.4497 165.667 -80.7894 161.136C-83.4613 157.511 -88.4408 153.965 -90.5965 152.645C-94.4472 150.499 -104.2 147.219 -112.404 151.267Z",
    fill: "url(#paint63_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.943 271.981C182.965 273.777 176.693 272.991 174.678 272.373C179.705 279.063 177.212 276.622 183.737 288.38C188.957 297.786 197.22 301.234 200.699 301.782C203.362 302.12 210.018 302.497 215.344 301.305C220.669 300.113 227.522 301.667 230.283 302.594C224.917 298.554 221.96 294.894 219.913 289.657C218.275 285.467 214.387 280.76 212.648 278.929C209.487 275.865 200.92 270.185 191.943 271.981Z",
    fill: "url(#paint64_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-92.1838 108.737C-101.161 110.533 -107.434 109.747 -109.448 109.129C-104.422 115.819 -106.914 113.378 -100.39 125.136C-95.17 134.542 -86.9064 137.99 -83.427 138.538C-80.7646 138.876 -74.1084 139.253 -68.7829 138.061C-63.4573 136.869 -56.6044 138.424 -53.8437 139.35C-59.2093 135.31 -62.1661 131.65 -64.2136 126.413C-65.8516 122.223 -69.7391 117.516 -71.4782 115.685C-74.6395 112.621 -83.2065 106.941 -92.1838 108.737Z",
    fill: "url(#paint65_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.397 303.727C161.258 303.15 155.403 300.775 153.618 299.659C156.734 307.415 154.961 304.416 158.205 317.453C160.801 327.883 167.886 333.342 171.104 334.768C173.588 335.78 179.919 337.858 185.374 338.079C190.828 338.299 197.043 341.566 199.469 343.171C195.336 337.887 193.432 333.59 192.817 328.004C192.324 323.536 189.793 317.987 188.59 315.771C186.333 311.997 179.535 304.304 170.397 303.727Z",
    fill: "url(#paint66_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61.5919 72.8649C-70.7305 72.2878 -76.585 69.9126 -78.37 68.7972C-75.2546 76.5531 -77.0274 73.5539 -73.7832 86.5915C-71.1878 97.0216 -64.1024 102.48 -60.8842 103.906C-58.4003 104.918 -52.0691 106.997 -46.6149 107.217C-41.1607 107.437 -34.9457 110.704 -32.52 112.31C-36.6521 107.025 -38.5562 102.728 -39.1719 97.1425C-39.6644 92.6738 -42.1951 87.1251 -43.3989 84.9093C-45.6555 81.135 -52.4533 73.4421 -61.5919 72.8649Z",
    fill: "url(#paint67_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.328 328.841C132.651 325.93 127.614 322.128 126.18 320.591C127.172 328.885 126.239 325.531 125.982 338.96C125.776 349.703 131.201 356.801 133.938 359.007C136.074 360.624 141.649 364.263 146.86 365.88C152.071 367.497 157.225 372.254 159.151 374.43C156.533 368.261 155.812 363.62 156.67 358.066C157.356 353.623 156.355 347.611 155.769 345.161C154.57 340.934 150.005 331.753 141.328 328.841Z",
    fill: "url(#paint68_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.7125 46.0943C-31.3896 43.1831 -36.427 39.381 -37.861 37.8438C-36.869 46.1378 -37.8013 42.7842 -38.0584 56.2131C-38.2641 66.9563 -32.84 74.0541 -30.1022 76.2601C-27.9661 77.8772 -22.3912 81.5157 -17.1802 83.1331C-11.9691 84.7505 -6.81548 89.5068 -4.89006 91.6828C-7.50708 85.5145 -8.22871 80.8734 -7.37064 75.3192C-6.68417 70.8759 -7.6855 64.8645 -8.27197 62.4142C-9.47003 58.1872 -14.0355 49.0056 -22.7125 46.0943Z",
    fill: "url(#paint69_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.718 345.613C99.0939 340.566 95.2171 335.596 94.2317 333.742C93.0328 342.009 93.0044 338.529 89.2634 351.435C86.2706 361.759 89.6639 370.012 91.7347 372.848C93.3774 374.96 97.8161 379.91 102.429 382.815C107.042 385.719 110.783 391.641 112.077 394.239C111.153 387.606 111.663 382.938 113.936 377.794C115.755 373.679 116.351 367.614 116.422 365.096C116.364 360.705 114.342 350.66 106.718 345.613Z",
    fill: "url(#paint70_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8044 30.2498C14.1801 25.2028 10.3033 20.2328 9.31793 18.3787C8.11902 26.6456 8.09067 23.1661 4.34969 36.0713C1.35689 46.3954 4.75018 54.6484 6.82095 57.4844C8.46367 59.5965 12.9023 64.5469 17.5152 67.4514C22.128 70.3559 25.869 76.2775 27.1629 78.8752C26.2393 72.2431 26.7493 67.5743 29.0227 62.4304C30.8414 58.3153 31.4377 52.2507 31.5084 49.7329C31.4505 45.3414 29.4287 35.2967 21.8044 30.2498Z",
    fill: "url(#paint71_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9358 24.6681C85.9868 31.2967 83.2093 37.7061 82.8142 40.0823C82.3983 36.6711 80.4032 28.6084 75.7509 23.6464C71.0986 18.6844 68.7151 10.7361 67.8985 7.43702C67.6585 4.751 69.8393 0.452911 73.6409 1.17902C77.4426 1.90512 78.057 5.79416 77.8889 7.64791C77.6575 9.17525 77.3398 13.0497 77.9202 16.3288C78.5006 19.6079 79.8888 23.8081 80.5104 25.4984C81.2703 27.7808 82.7951 33.893 82.8142 40.0823C83.5542 33.8871 87.7295 26.06 89.7247 22.9208C90.3265 22.0929 91.9194 19.7946 93.4762 17.2255C95.0329 14.6563 95.6412 10.9128 95.7507 9.36221C96.2326 7.19123 98.1763 3.07416 102.096 3.9737C106.016 4.87323 105.863 9.65932 105.297 11.9399C104.822 13.4207 101.885 18.0395 93.9358 24.6681Z",
    fill: "url(#paint72_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.926 15.9817C86.0652 22.6368 83.7903 31.0909 83.1355 34.4861C83.8076 27.0711 82.6113 23.4481 81.7585 17.0619C81.0761 11.9529 81.615 8.04527 81.8722 6.71145L82.2884 5.47085C85.3457 0.623554 89.0492 1.85893 90.5187 3.08254C91.9298 4.60928 93.7868 9.32655 89.926 15.9817Z",
    fill: "url(#paint73_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2612 395.654C34.113 388.911 36.797 382.463 37.1575 380.081C37.623 383.486 39.7351 391.519 44.459 396.413C49.183 401.308 51.6819 409.221 52.5464 412.508C52.8254 415.19 50.7073 419.519 46.8955 418.848C43.0837 418.177 42.4128 414.297 42.5539 412.441C42.763 410.911 43.0244 407.032 42.3963 403.762C41.7683 400.491 40.3192 396.311 39.6732 394.63C38.8801 392.359 37.2666 386.269 37.1575 380.081C36.5077 386.286 32.4466 394.173 30.4973 397.34C29.9075 398.177 28.3482 400.498 26.829 403.089C25.3098 405.68 24.756 409.432 24.669 410.984C24.2188 413.162 22.3351 417.306 18.4026 416.463C14.4702 415.62 14.553 410.833 15.086 408.544C15.5395 407.057 18.4094 402.396 26.2612 395.654Z",
    fill: "url(#paint74_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3969 404.281C34.1606 397.571 36.3122 389.085 36.9176 385.681C36.3534 393.105 37.6022 396.711 38.5479 403.084C39.3044 408.182 38.8224 412.097 38.5846 413.435L38.1865 414.681C35.2 419.572 31.479 418.39 29.9918 417.188C28.5586 415.682 26.6333 410.991 30.3969 404.281Z",
    fill: "url(#paint75_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.985 39.6605C131.583 44.0159 127.233 49.4916 126.234 51.685C126.719 48.2829 126.889 39.9811 123.686 33.9899C120.482 27.9987 120.247 19.7073 120.316 16.3103C120.783 13.654 124.008 10.0641 127.491 11.7446C130.974 13.4252 130.556 17.3399 129.912 19.0872C129.291 20.5029 127.976 24.1635 127.684 27.4804C127.392 30.7972 127.64 35.2119 127.801 37.0046C127.942 39.405 127.825 45.7017 126.234 51.685C128.56 45.8916 134.628 39.4065 137.372 36.8882C138.169 36.2435 140.305 34.4338 142.477 32.3531C144.649 30.2725 146.21 26.8132 146.719 25.3436C147.749 23.3708 150.697 19.8946 154.25 21.7731C157.802 23.6516 156.41 28.2353 155.27 30.2924C154.426 31.6003 150.387 35.3051 140.985 39.6605Z",
    fill: "url(#paint76_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.371 30.2373C133.911 35.6712 129.515 43.2514 127.999 46.3622C130.577 39.373 130.364 35.5653 131.201 29.1771C131.871 24.0665 133.407 20.4307 134.003 19.2086L134.727 18.1175C138.941 14.2228 142.197 16.37 143.299 17.9304C144.264 19.7685 144.831 24.8034 139.371 30.2373Z",
    fill: "url(#paint77_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.8702 380.575C-11.5324 376.084 -7.26268 370.547 -6.29504 368.339C-6.73091 371.748 -6.78011 380.051 -3.49005 385.996C-0.199997 391.94 0.155609 400.227 0.135757 403.625C-0.292343 406.288 -3.46416 409.923 -6.9715 408.293C-10.4788 406.663 -10.1178 402.743 -9.49883 400.986C-8.89873 399.562 -7.63753 395.883 -7.3936 392.562C-7.14966 389.241 -7.46227 384.831 -7.64906 383.04C-7.82442 380.642 -7.79909 374.345 -6.29504 368.339C-8.53659 374.165 -14.5104 380.737 -17.2171 383.295C-18.0043 383.951 -20.1142 385.791 -22.2555 387.903C-24.3969 390.014 -25.9077 393.496 -26.3954 394.973C-27.3966 396.96 -30.294 400.478 -33.8733 398.651C-37.4525 396.824 -36.1273 392.221 -35.0173 390.147C-34.1923 388.828 -30.208 385.065 -20.8702 380.575Z",
    fill: "url(#paint78_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.1194 389.974C-13.7388 384.462 -9.45343 376.819 -7.98329 373.687C-10.4591 380.712 -10.1905 384.517 -10.9346 390.916C-11.53 396.036 -13.0137 399.693 -13.5913 400.924L-14.3 402.025C-18.4568 405.98 -21.7436 403.88 -22.8674 402.336C-23.86 400.512 -24.4999 395.486 -19.1194 389.974Z",
    fill: "url(#paint79_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.533 66.2786C172.318 68.064 166.693 72.2327 165.157 74.0939C166.51 70.9328 168.833 62.9576 167.298 56.3455C165.762 49.7334 167.691 41.664 168.641 38.4006C169.783 35.9551 173.831 33.3179 176.759 35.8383C179.686 38.3588 178.264 42.0325 177.187 43.5542C176.22 44.7618 173.998 47.9591 172.853 51.0877C171.708 54.2162 170.8 58.5445 170.489 60.3175C170 62.6723 168.25 68.7243 165.157 74.0939C168.91 69.097 176.459 64.396 179.764 62.6701C180.701 62.2526 183.235 61.0548 185.874 59.6045C188.513 58.1541 190.921 55.2148 191.795 53.9264C193.303 52.2861 197.055 49.6877 199.998 52.4171C202.94 55.1465 200.403 59.2156 198.767 60.9089C197.612 61.9549 192.747 64.4933 182.533 66.2786Z",
    fill: "url(#paint80_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.425 56.7608C176.737 60.6033 170.52 66.7929 168.247 69.4073C172.554 63.3202 173.339 59.5873 175.809 53.6323C177.785 48.8684 180.215 45.7523 181.108 44.7252L182.091 43.8579C187.174 41.1813 189.761 44.0939 190.419 45.8848C190.874 47.9091 190.112 52.9183 183.425 56.7608Z",
    fill: "url(#paint81_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.4728 353.888C-52.2854 351.956 -46.7209 347.707 -45.2121 345.824C-46.5196 349.004 -48.7267 357.012 -47.0948 363.601C-45.4629 370.19 -47.2747 378.287 -48.1775 381.564C-49.2836 384.025 -53.293 386.72 -56.2568 384.242C-59.2207 381.764 -57.8523 378.071 -56.7976 376.533C-55.8475 375.312 -53.6724 372.083 -52.5731 368.938C-51.4738 365.794 -50.6287 361.453 -50.3435 359.675C-49.8891 357.314 -48.2268 351.237 -45.2121 345.824C-48.8925 350.874 -56.372 355.683 -59.6516 357.457C-60.5827 357.888 -63.0992 359.122 -65.7169 360.61C-68.3345 362.098 -70.6992 365.072 -71.5543 366.373C-73.0384 368.035 -76.7521 370.687 -79.7342 368C-82.7162 365.313 -80.239 361.208 -78.6276 359.491C-77.4874 358.429 -72.6603 355.821 -62.4728 353.888Z",
    fill: "url(#paint82_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-63.2262 363.418C-56.5954 359.48 -50.4683 353.201 -48.2336 350.554C-52.4523 356.703 -53.1822 360.447 -55.5654 366.437C-57.472 371.228 -59.8565 374.379 -60.7344 375.419L-61.7054 376.3C-66.7491 379.05 -69.3778 376.175 -70.0616 374.394C-70.546 372.376 -69.8569 367.356 -63.2262 363.418Z",
    fill: "url(#paint83_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.748 102.708C205.417 101.802 198.899 104.38 196.931 105.782C199.061 103.077 203.379 95.9721 203.615 89.1897C203.851 82.4073 207.813 75.1098 209.58 72.2024C211.319 70.1342 215.915 68.6296 218.087 71.8181C220.26 75.0067 217.931 78.189 216.495 79.3815C215.246 80.2987 212.268 82.8148 210.349 85.5419C208.429 88.2689 206.426 92.2158 205.665 93.8483C204.58 95.997 201.315 101.392 196.931 105.782C201.856 101.922 210.37 99.3254 214.012 98.5096C215.025 98.3477 217.785 97.8435 220.711 97.1222C223.637 96.401 226.728 94.182 227.907 93.1626C229.79 91.9666 234.09 90.4231 236.222 93.8174C238.355 97.2118 234.846 100.489 232.826 101.703C231.437 102.416 226.079 103.615 215.748 102.708Z",
    fill: "url(#paint84_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.085 93.7445C211.626 95.7337 204.01 100.111 201.135 102.051C206.879 97.2806 208.607 93.8769 212.542 88.7611C215.689 84.6684 218.847 82.2844 219.977 81.5223L221.153 80.9379C226.759 79.6617 228.5 83.1413 228.669 85.0406C228.582 87.1131 226.543 91.7554 219.085 93.7445Z",
    fill: "url(#paint85_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-95.7115 317.414C-85.3687 318.171 -78.8886 315.5 -76.9414 314.07C-79.0315 316.805 -83.2461 323.971 -83.3836 330.756C-83.521 337.541 -87.3768 344.895 -89.1011 347.828C-90.8097 349.921 -95.3835 351.491 -97.6018 348.334C-99.8202 345.178 -97.5378 341.962 -96.1193 340.749C-94.8838 339.814 -91.9431 337.255 -90.0634 334.501C-88.1837 331.746 -86.2383 327.771 -85.5006 326.128C-84.4475 323.964 -81.2614 318.522 -76.9414 314.07C-81.81 318 -90.2854 320.719 -93.9145 321.587C-94.9259 321.764 -97.6777 322.307 -100.593 323.071C-103.509 323.834 -106.566 326.097 -107.731 327.134C-109.596 328.357 -113.873 329.962 -116.055 326.599C-118.237 323.235 -114.776 319.908 -112.773 318.665C-111.395 317.932 -106.054 316.656 -95.7115 317.414Z",
    fill: "url(#paint86_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-98.9177 326.425C-91.4886 324.328 -83.9373 319.842 -81.0903 317.861C-86.7644 322.713 -88.4432 326.141 -92.3031 331.313C-95.391 335.451 -98.5136 337.88 -99.632 338.659L-100.799 339.26C-106.386 340.617 -108.178 337.162 -108.375 335.266C-108.318 333.192 -106.347 328.521 -98.9177 326.425Z",
    fill: "url(#paint87_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.366 146.467C228.623 142.931 221.656 143.742 219.391 144.589C222.152 142.525 228.171 136.775 230.163 130.284C232.155 123.794 237.88 117.765 240.343 115.412C242.56 113.862 247.391 113.593 248.66 117.232C249.929 120.871 246.852 123.345 245.154 124.128C243.71 124.692 240.179 126.355 237.616 128.495C235.052 130.635 232.091 133.931 230.931 135.312C229.325 137.108 224.768 141.478 219.391 144.589C225.152 142.13 234.052 141.814 237.781 141.964C238.803 142.069 241.599 142.293 244.613 142.35C247.627 142.407 251.189 141.059 252.594 140.378C254.724 139.708 259.278 139.325 260.456 143.153C261.633 146.981 257.391 149.242 255.124 149.895C253.597 150.226 248.109 150.003 238.366 146.467Z",
    fill: "url(#paint88_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.921 138.668C236.199 138.668 227.704 140.935 224.422 142.068C231.211 138.94 233.766 136.097 238.897 132.169C243.002 129.027 246.672 127.537 247.961 127.092L249.249 126.831C254.996 127.042 255.772 130.851 255.442 132.729C254.819 134.709 251.643 138.668 243.921 138.668Z",
    fill: "url(#paint89_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-118.321 273.636C-108.528 277.032 -101.574 276.121 -99.321 275.241C-102.051 277.344 -107.986 283.181 -109.883 289.7C-111.781 296.218 -117.418 302.328 -119.846 304.717C-122.041 306.298 -126.867 306.637 -128.189 303.017C-129.511 299.396 -126.47 296.878 -124.784 296.071C-123.348 295.486 -119.842 293.772 -117.31 291.596C-114.777 289.419 -111.865 286.081 -110.725 284.683C-109.145 282.864 -104.652 278.429 -99.321 275.241C-105.046 277.783 -113.94 278.227 -117.671 278.13C-118.694 278.04 -121.493 277.857 -124.508 277.843C-127.523 277.83 -131.064 279.228 -132.459 279.929C-134.579 280.63 -139.128 281.079 -140.36 277.269C-141.593 273.458 -137.385 271.135 -135.127 270.451C-133.606 270.098 -128.115 270.241 -118.321 273.636Z",
    fill: "url(#paint90_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-123.762 281.514C-116.041 281.403 -107.58 279.014 -104.314 277.834C-111.057 281.06 -113.57 283.939 -118.644 287.94C-122.703 291.142 -126.351 292.684 -127.634 293.147L-128.917 293.428C-134.667 293.299 -135.499 289.501 -135.196 287.618C-134.602 285.63 -131.483 281.626 -123.762 281.514Z",
    fill: "url(#paint91_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.847 194.573C240.355 188.648 233.415 187.637 231.007 187.872C234.21 186.589 241.52 182.585 245.132 176.828C248.744 171.072 255.842 166.724 258.833 165.085C261.378 164.159 266.114 165.143 266.393 168.985C266.673 172.827 263.057 174.425 261.214 174.743C259.672 174.916 255.829 175.613 252.796 177.02C249.763 178.426 246.046 180.848 244.566 181.883C242.547 183.204 237.009 186.251 231.007 187.872C237.211 186.98 245.889 188.967 249.453 190.073C250.412 190.437 253.055 191.373 255.952 192.205C258.849 193.036 262.64 192.652 264.173 192.356C266.405 192.257 270.904 193.06 271.046 197.061C271.187 201.061 266.502 202.154 264.142 202.2C262.582 202.126 257.338 200.498 248.847 194.573Z",
    fill: "url(#paint92_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.24 188.47C248.781 186.482 239.987 186.483 236.522 186.732C243.893 185.459 247.1 183.372 253.078 180.899C257.86 178.921 261.793 178.427 263.154 178.329L264.466 178.408C269.962 180.093 269.721 183.972 268.914 185.701C267.797 187.453 263.699 190.459 256.24 188.47Z",
    fill: "url(#paint93_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128.761 225.54C-120.185 231.342 -113.231 232.253 -110.826 231.983C-114.01 233.312 -121.261 237.421 -124.789 243.229C-128.317 249.036 -135.351 253.486 -138.318 255.168C-140.849 256.13 -145.599 255.215 -145.934 251.377C-146.269 247.539 -142.677 245.89 -140.839 245.545C-139.299 245.35 -135.467 244.598 -132.455 243.148C-129.443 241.698 -125.761 239.223 -124.296 238.167C-122.297 236.816 -116.804 233.689 -110.826 231.983C-117.017 232.964 -125.723 231.102 -129.302 230.048C-130.266 229.698 -132.923 228.799 -135.831 228.01C-138.739 227.22 -142.525 227.659 -144.054 227.977C-146.284 228.108 -150.794 227.37 -150.994 223.372C-151.193 219.373 -146.525 218.214 -144.165 218.134C-142.604 218.185 -137.338 219.737 -128.761 225.54Z",
    fill: "url(#paint94_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-136.065 231.748C-128.578 233.629 -119.784 233.501 -116.323 233.202C-123.675 234.581 -126.852 236.714 -132.793 239.273C-137.546 241.32 -141.471 241.87 -142.831 241.987L-144.143 241.927C-149.664 240.322 -149.48 236.44 -148.697 234.699C-147.606 232.931 -143.552 229.867 -136.065 231.748Z",
    fill: "url(#paint95_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.475 243.747C239.814 235.837 233.374 233.073 230.986 232.68C234.414 232.266 242.516 230.28 247.502 225.65C252.488 221.021 260.475 218.649 263.79 217.836C266.489 217.597 270.809 219.768 270.079 223.551C269.349 227.334 265.441 227.945 263.578 227.778C262.044 227.548 258.15 227.232 254.855 227.809C251.56 228.387 247.339 229.768 245.641 230.387C243.347 231.143 237.205 232.66 230.986 232.68C237.211 233.416 245.077 237.571 248.231 239.556C249.063 240.155 251.372 241.741 253.954 243.29C256.536 244.839 260.298 245.444 261.856 245.553C264.037 246.033 268.174 247.967 267.271 251.868C266.367 255.769 261.557 255.617 259.265 255.053C257.777 254.581 253.136 251.657 246.475 243.747Z",
    fill: "url(#paint96_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.204 239.757C248.516 235.915 240.021 233.651 236.609 232.999C244.06 233.668 247.701 232.478 254.119 231.629C259.252 230.95 263.179 231.486 264.519 231.742L265.766 232.156C270.637 235.199 269.396 238.884 268.166 240.347C266.632 241.751 261.892 243.599 255.204 239.757Z",
    fill: "url(#paint97_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-126.32 176.401C-119.545 184.215 -113.064 186.885 -110.671 187.244C-114.093 187.708 -122.165 189.809 -127.083 194.51C-132.002 199.211 -139.953 201.698 -143.256 202.558C-145.952 202.836 -150.302 200.728 -149.627 196.935C-148.953 193.142 -145.054 192.474 -143.189 192.614C-141.651 192.823 -137.754 193.083 -134.467 192.458C-131.181 191.833 -126.981 190.391 -125.291 189.748C-123.009 188.958 -116.89 187.353 -110.671 187.244C-116.907 186.598 -124.831 182.556 -128.014 180.616C-128.855 180.029 -131.187 178.478 -133.791 176.966C-136.395 175.454 -140.165 174.903 -141.725 174.816C-143.913 174.368 -148.078 172.494 -147.231 168.58C-146.384 164.667 -141.573 164.749 -139.273 165.28C-137.778 165.731 -133.095 168.587 -126.32 176.401Z",
    fill: "url(#paint98_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-134.99 180.516C-128.247 184.262 -119.72 186.403 -116.299 187.006C-123.759 186.444 -127.382 187.687 -133.786 188.628C-138.91 189.381 -142.844 188.901 -144.188 188.664L-145.44 188.268C-150.355 185.296 -149.167 181.593 -147.959 180.113C-146.445 178.687 -141.732 176.771 -134.99 180.516Z",
    fill: "url(#paint99_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.41 290.568C227.033 281.211 221.531 276.883 219.327 275.888C222.745 276.371 231.087 276.54 237.108 273.352C243.128 270.165 251.46 269.931 254.874 270C257.543 270.464 261.15 273.673 259.462 277.139C257.773 280.605 253.839 280.19 252.083 279.548C250.661 278.93 246.982 277.622 243.649 277.332C240.316 277.041 235.88 277.288 234.078 277.448C231.666 277.588 225.339 277.471 219.327 275.888C225.148 278.203 231.665 284.242 234.196 286.972C234.843 287.765 236.662 289.891 238.753 292.052C240.844 294.214 244.32 295.767 245.796 296.274C247.779 297.299 251.272 300.233 249.384 303.768C247.497 307.303 242.891 305.918 240.824 304.783C239.509 303.943 235.786 299.924 231.41 290.568Z",
    fill: "url(#paint100_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.879 288.962C235.418 283.528 227.801 279.153 224.675 277.645C231.699 280.21 235.525 279.998 241.944 280.831C247.08 281.498 250.733 283.027 251.961 283.619L253.058 284.341C256.971 288.534 254.814 291.774 253.246 292.87C251.399 293.831 246.339 294.395 240.879 288.962Z",
    fill: "url(#paint101_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-111.167 129.498C-106.655 138.791 -101.09 143.04 -98.872 144.003C-102.297 143.569 -110.641 143.52 -116.615 146.794C-122.588 150.068 -130.916 150.422 -134.33 150.402C-137.006 149.976 -140.659 146.82 -139.021 143.33C-137.383 139.839 -133.444 140.199 -131.679 140.815C-130.247 141.412 -126.55 142.667 -123.213 142.91C-119.876 143.152 -115.444 142.841 -113.645 142.655C-111.235 142.481 -104.907 142.506 -98.872 144.003C-104.727 141.772 -111.331 135.827 -113.901 133.134C-114.56 132.35 -116.409 130.251 -118.531 128.12C-120.653 125.989 -124.152 124.485 -125.635 124C-127.633 123.004 -131.168 120.12 -129.332 116.558C-127.496 112.997 -122.87 114.315 -120.787 115.42C-119.46 116.241 -115.68 120.206 -111.167 129.498Z",
    fill: "url(#paint102_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-120.612 131.241C-115.073 136.595 -107.393 140.86 -104.246 142.323C-111.306 139.859 -115.128 140.126 -121.559 139.386C-126.704 138.793 -130.379 137.317 -131.616 136.742L-132.723 136.037C-136.697 131.9 -134.587 128.629 -133.035 127.511C-131.202 126.523 -126.151 125.886 -120.612 131.241Z",
    fill: "url(#paint103_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.662 331.914C202.868 321.749 198.679 316.151 196.808 314.622C199.985 315.969 207.999 318.281 214.643 316.753C221.288 315.224 229.396 317.144 232.676 318.09C235.133 319.226 237.783 323.255 235.25 326.168C232.718 329.081 229.026 327.666 227.497 326.594C226.283 325.631 223.071 323.42 219.927 322.281C216.783 321.142 212.434 320.238 210.652 319.928C208.286 319.442 202.204 317.7 196.808 314.622C201.83 318.357 206.553 325.869 208.288 329.158C208.707 330.091 209.911 332.613 211.368 335.239C212.826 337.865 215.78 340.261 217.074 341.131C218.723 342.632 221.334 346.365 218.591 349.294C215.848 352.222 211.759 349.698 210.058 348.07C209.007 346.92 206.456 342.079 204.662 331.914Z",
    fill: "url(#paint104_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.226 332.801C210.365 326.146 204.145 319.959 201.518 317.697C207.635 321.984 211.386 322.764 217.37 325.222C222.157 327.189 225.288 329.607 226.32 330.496L227.192 331.475C229.881 336.533 226.955 339.107 225.155 339.762C223.121 340.214 218.087 339.456 214.226 332.801Z",
    fill: "url(#paint105_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84.3511 88.0977C-82.4094 98.2357 -78.1394 103.773 -76.2471 105.275C-79.4428 103.974 -87.4897 101.777 -94.1111 103.401C-100.733 105.025 -108.868 103.222 -112.161 102.324C-114.635 101.223 -117.343 97.233 -114.853 94.2836C-112.363 91.3341 -108.651 92.6958 -107.107 93.7454C-105.879 94.6909 -102.635 96.8555 -99.4744 97.9494C-96.3144 99.0433 -91.9523 99.8844 -90.1663 100.168C-87.7932 100.62 -81.687 102.275 -76.2471 105.275C-81.3221 101.612 -86.1548 94.169 -87.9367 90.9053C-88.3698 89.9787 -89.6099 87.4744 -91.1054 84.8694C-92.6009 82.2645 -95.5891 79.9113 -96.8962 79.0603C-98.5662 77.5834 -101.231 73.8878 -98.5314 70.9202C-95.8316 67.9526 -91.7064 70.4178 -89.9813 72.0214C-88.9136 73.156 -86.2927 77.9597 -84.3511 88.0977Z",
    fill: "url(#paint106_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.9272 87.3481C-89.9697 93.9466 -83.6605 100.044 -81.0007 102.268C-87.1792 98.0696 -90.9413 97.3432 -96.9604 94.9716C-101.776 93.0743 -104.942 90.7014 -105.987 89.8277L-106.872 88.8614C-109.635 83.8422 -106.746 81.2263 -104.956 80.5457C-102.929 80.0638 -97.8848 80.7495 -93.9272 87.3481Z",
    fill: "url(#paint107_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.054 364.967C168.965 354.687 166.375 348.2 164.966 346.242C167.684 348.361 174.824 352.659 181.639 352.894C188.454 353.129 195.788 357.072 198.709 358.83C200.788 360.56 202.299 365.134 199.095 367.296C195.891 369.457 192.693 367.14 191.495 365.711C190.573 364.468 188.045 361.505 185.305 359.595C182.564 357.684 178.598 355.691 176.958 354.933C174.798 353.854 169.377 350.605 164.966 346.242C168.845 351.143 171.454 359.616 172.274 363.24C172.436 364.249 172.943 366.995 173.668 369.907C174.393 372.819 176.622 375.894 177.647 377.067C178.849 378.942 180.4 383.221 176.989 385.343C173.578 387.465 170.285 383.973 169.065 381.962C168.348 380.581 167.144 375.248 168.054 364.967Z",
    fill: "url(#paint108_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.062 368.288C175.063 360.865 170.665 353.287 168.715 350.425C173.509 356.141 176.929 357.861 182.07 361.777C186.182 364.909 188.578 368.052 189.344 369.176L189.931 370.346C191.213 375.925 187.717 377.657 185.808 377.826C183.726 377.74 179.061 375.711 177.062 368.288Z",
    fill: "url(#paint109_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-47.6985 55.0202C-48.4597 65.3129 -45.7754 71.7615 -44.338 73.6992C-47.0865 71.6192 -54.2879 67.4251 -61.1061 67.2884C-67.9243 67.1516 -75.314 63.3145 -78.2608 61.5986C-80.364 59.8982 -81.9424 55.3467 -78.77 53.1391C-75.5977 50.9315 -72.3665 53.2029 -71.1475 54.6145C-70.2078 55.8439 -67.6367 58.7704 -64.8688 60.641C-62.1009 62.5116 -58.1063 64.4475 -56.4549 65.1816C-54.2803 66.2296 -48.8124 69.4002 -44.338 73.6992C-48.2876 68.8542 -51.0198 60.42 -51.8921 56.8086C-52.0695 55.802 -52.6161 53.0636 -53.3831 50.1623C-54.1501 47.2609 -56.4244 44.2182 -57.4657 43.0596C-58.6947 41.2029 -60.3078 36.9467 -56.9281 34.7756C-53.5484 32.6046 -50.205 36.0483 -48.9557 38.0416C-48.2195 39.4125 -46.9373 44.7275 -47.6985 55.0202Z",
    fill: "url(#paint110_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.7534 51.8296C-54.6468 59.2227 -50.1385 66.7373 -48.1477 69.5704C-53.0238 63.9239 -56.4687 62.2533 -61.6659 58.4122C-65.8237 55.3392 -68.2647 52.2318 -69.0469 51.1188L-69.651 49.9572C-71.0144 44.3974 -67.5435 42.6147 -65.6376 42.4184C-63.5539 42.475 -58.8599 44.4366 -56.7534 51.8296Z",
    fill: "url(#paint111_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.082 387.476C127.636 377.78 126.821 370.848 125.969 368.593C128.043 371.34 133.822 377.33 140.344 379.313C146.866 381.295 152.924 386.992 155.289 389.443C156.846 391.65 157.117 396.457 153.46 397.72C149.803 398.983 147.317 395.921 146.531 394.232C145.964 392.794 144.292 389.28 142.142 386.729C139.992 384.178 136.679 381.231 135.292 380.077C133.487 378.478 129.095 373.944 125.969 368.593C128.441 374.327 128.758 383.183 128.607 386.894C128.502 387.91 128.277 390.693 128.22 393.693C128.162 396.692 129.516 400.237 130.201 401.634C130.874 403.754 131.259 408.287 127.413 409.458C123.566 410.63 121.293 406.409 120.638 404.152C120.305 402.633 120.529 397.172 124.082 387.476Z",
    fill: "url(#paint112_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.919 393.004C131.919 385.319 129.641 376.866 128.503 373.6C131.646 380.356 134.502 382.898 138.45 388.004C141.608 392.089 143.104 395.741 143.552 397.025L143.815 398.306C143.602 404.025 139.774 404.798 137.887 404.47C135.898 403.849 131.919 400.688 131.919 393.004Z",
    fill: "url(#paint113_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.70753 32.5201C-7.11975 42.266 -6.20403 49.1863 -5.31964 51.4282C-7.43349 48.7112 -13.2987 42.8052 -19.849 40.9169C-26.3993 39.0287 -32.5393 33.419 -34.9394 31.0026C-36.5287 28.8185 -36.8695 24.0155 -33.2311 22.7002C-29.5927 21.3849 -27.0623 24.4111 -26.252 26.0886C-25.6641 27.5182 -23.9417 31.0072 -21.7546 33.5269C-19.5676 36.0467 -16.2125 38.9455 -14.8084 40.0799C-12.9804 41.6523 -8.52341 46.1232 -5.31964 51.4282C-7.87456 45.731 -8.32002 36.8805 -8.2234 33.1674C-8.13297 32.1495 -7.94867 29.3636 -7.93497 26.3636C-7.92126 23.3635 -9.32675 19.8387 -10.0312 18.4514C-10.7354 16.3414 -11.1866 11.8148 -7.35742 10.5882C-3.52823 9.36154 -1.19438 13.5491 -0.506119 15.7962C-0.151505 17.31 -0.295334 22.7742 -3.70753 32.5201Z",
    fill: "url(#paint114_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.6241 27.1061C-11.5121 34.7898 -9.1118 43.2095 -7.92564 46.4589C-11.1671 39.7488 -14.0601 37.2479 -18.0813 32.199C-21.2981 28.1599 -22.8478 24.5296 -23.3138 23.2531L-23.5953 21.9755C-23.4662 16.2539 -19.6499 15.426 -17.7578 15.7273C-15.7599 16.3187 -11.736 19.4223 -11.6241 27.1061Z",
    fill: "url(#paint115_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7419 397.906C81.696 389.456 82.7119 382.549 82.4755 380.152C83.7645 383.34 87.7885 390.614 93.5728 394.209C99.3572 397.804 103.727 404.867 105.374 407.844C106.304 410.376 105.315 415.09 101.454 415.367C97.5933 415.645 95.9884 412.047 95.6686 410.213C95.4949 408.678 94.7941 404.854 93.3806 401.836C91.9672 398.818 89.5339 395.118 88.4939 393.646C87.1662 391.637 84.1037 386.126 82.4755 380.152C83.372 386.327 81.3747 394.963 80.2639 398.509C79.8979 399.464 78.957 402.094 78.1215 404.976C77.286 407.859 77.6721 411.632 77.9695 413.158C78.0687 415.379 77.2621 419.856 73.2419 419.997C69.2217 420.138 68.1241 415.475 68.0779 413.127C68.1516 411.574 69.7878 406.356 75.7419 397.906Z",
    fill: "url(#paint116_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8743 405.263C83.8726 397.841 83.8712 389.089 83.6207 385.641C84.9 392.976 86.9978 396.167 89.4825 402.116C91.4703 406.876 91.9662 410.789 92.0646 412.143L91.9852 413.449C90.2928 418.919 86.3942 418.679 84.6565 417.876C82.8964 416.764 79.8759 412.686 81.8743 405.263Z",
    fill: "url(#paint117_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6239 22.1309C38.7933 30.6658 37.8779 37.5861 38.1491 39.9794C36.8139 36.8106 32.6846 29.5951 26.8486 26.0841C21.0126 22.5731 16.5408 15.5732 14.851 12.6209C13.8838 10.1019 14.8038 5.37481 18.6603 5.04144C22.5169 4.70808 24.1739 8.28288 24.5204 10.1119C24.7164 11.6442 25.4727 15.4579 26.9299 18.4551C28.3871 21.4523 30.8739 25.1165 31.9352 26.5739C33.2919 28.5636 36.4342 34.0301 38.1491 39.9794C37.163 33.8184 39.0345 25.1547 40.0936 21.593C40.4457 20.633 41.3483 17.9896 42.1418 15.0953C42.9352 12.201 42.4944 8.43431 42.1748 6.91276C42.0433 4.6933 42.7848 0.204748 46.8025 0.00616782C50.8202 -0.192412 51.9855 4.45356 52.0659 6.80136C52.0147 8.35497 50.4546 13.5959 44.6239 22.1309Z",
    fill: "url(#paint118_radial_218_14601)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3852 14.8623C36.495 22.313 36.6237 31.0641 36.9243 34.5082C35.5385 27.192 33.3945 24.0311 30.8235 18.1186C28.7667 13.3886 28.2141 9.48282 28.0959 8.12975L28.1563 6.82322C29.7691 1.32985 33.6707 1.51311 35.4199 2.29141C37.1959 3.37723 40.2755 7.41156 38.3852 14.8623Z",
    fill: "url(#paint119_radial_218_14601)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_218_14601_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M77.7685 64.2274C81.6626 64.8267 89.1064 68.5536 87.7294 78.6666C86.7834 85.614 83.4438 88.7351 80.3146 91.6595C77.7501 94.0563 75.3269 96.3209 74.4784 100.452C74.3879 96.2365 72.412 93.5761 70.3209 90.7606C67.7694 87.3253 65.0462 83.6589 65.3674 76.6552C65.8347 66.4604 73.8295 64.1222 77.7685 64.2274Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M40.7462 345.146C36.9259 344.186 29.8665 339.78 32.1915 329.84C33.7888 323.012 37.4081 320.217 40.7993 317.598C43.5787 315.451 46.2048 313.423 47.4392 309.39C47.1316 313.595 48.8478 316.428 50.6641 319.426C52.8803 323.085 55.2455 326.99 54.2651 333.932C52.8379 344.038 44.6579 345.619 40.7462 345.146Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M113.807 73.7803C117.412 75.3622 123.633 80.8794 119.673 90.2931C116.952 96.7601 112.914 98.9147 109.131 100.934C106.031 102.588 103.101 104.151 101.207 107.923C102.216 103.828 101 100.749 99.7119 97.4913C98.1408 93.5157 96.464 89.2729 98.5957 82.5906C101.699 72.8636 110.029 72.6642 113.807 73.7803Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M4.98393 335.592C1.54356 333.68 -4.12941 327.606 0.701523 318.604C4.02028 312.42 8.24324 310.652 12.2001 308.995C15.443 307.638 18.5072 306.355 20.7485 302.777C19.3578 306.76 20.2786 309.938 21.2532 313.303C22.4423 317.407 23.7114 321.788 20.9587 328.242C16.9518 337.636 8.63931 337.056 4.98393 335.592Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M146.132 92.2188C149.203 94.6754 153.777 101.607 147.503 109.68C143.193 115.226 138.733 116.267 134.554 117.243C131.128 118.042 127.892 118.798 125.082 121.953C127.121 118.257 126.747 114.97 126.35 111.492C125.867 107.247 125.351 102.717 129.148 96.8111C134.675 88.2148 142.773 90.1677 146.132 92.2188Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-27.0753 317.081C-29.9013 314.348 -33.8012 307.02 -26.7936 299.569C-21.9795 294.45 -17.4406 293.83 -13.1878 293.249C-9.70229 292.773 -6.40889 292.323 -3.31345 289.445C-5.69255 292.933 -5.62979 296.241 -5.56337 299.741C-5.48233 304.012 -5.39584 308.571 -9.73318 314.095C-16.0468 322.137 -23.9253 319.437 -27.0753 317.081Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M172.541 118.286C174.868 121.45 177.484 129.324 169.324 135.506C163.719 139.752 159.14 139.609 154.849 139.475C151.333 139.366 148.01 139.262 144.475 141.585C147.406 138.541 147.899 135.27 148.421 131.807C149.058 127.583 149.738 123.074 154.941 118.348C162.516 111.468 169.83 115.44 172.541 118.286Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-53.2466 290.875C-55.2655 287.507 -57.1266 279.424 -48.4199 274.032C-42.4385 270.327 -37.8931 270.898 -33.6341 271.432C-30.1435 271.87 -26.8454 272.284 -23.1068 270.3C-26.3121 273.057 -27.1117 276.268 -27.958 279.667C-28.9905 283.813 -30.0925 288.238 -35.7189 292.458C-43.909 298.6 -50.8166 293.961 -53.2466 290.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M191.234 150.206C192.66 153.862 193.139 162.141 183.649 166.01C177.13 168.669 172.744 167.351 168.635 166.117C165.267 165.105 162.084 164.149 158.065 165.483C161.688 163.297 163.016 160.264 164.42 157.054C166.134 153.138 167.963 148.958 174.219 145.733C183.324 141.038 189.357 146.759 191.234 150.206Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-71.7463 258.759C-72.8206 254.987 -72.5161 246.7 -62.7035 243.734C-55.9625 241.696 -51.7203 243.418 -47.7454 245.031C-44.4877 246.353 -41.4095 247.602 -37.2824 246.649C-41.0956 248.486 -42.7031 251.382 -44.4043 254.447C-46.4801 258.186 -48.6955 262.177 -55.2276 264.803C-64.736 268.626 -70.2019 262.367 -71.7463 258.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M200.939 185.803C201.365 189.701 199.674 197.821 189.502 199.115C182.513 200.004 178.619 197.602 174.971 195.351C171.981 193.506 169.156 191.763 164.927 192.016C168.995 190.838 171.065 188.25 173.257 185.512C175.931 182.17 178.785 178.603 185.666 177.099C195.683 174.91 200.021 181.99 200.939 185.803Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-81.3138 222.924C-81.3703 219.003 -78.9209 211.077 -68.6713 210.739C-61.6301 210.507 -57.9801 213.262 -54.5602 215.844C-51.7573 217.96 -49.1089 219.96 -44.8747 220.103C-49.0358 220.895 -51.3416 223.278 -53.7819 225.8C-56.7595 228.877 -59.9373 232.161 -66.9299 233.016C-77.1086 234.26 -80.7603 226.806 -81.3138 222.924Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M200.992 222.652C200.39 226.527 196.645 233.935 186.482 232.564C179.501 231.623 176.365 228.299 173.426 225.185C171.017 222.633 168.742 220.222 164.591 219.378C168.827 219.288 171.5 217.321 174.329 215.24C177.781 212.701 181.466 209.991 188.503 210.311C198.748 210.776 201.098 218.732 200.992 222.652Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-81.2974 185.809C-80.3322 182.008 -75.9048 174.982 -65.9167 177.296C-59.055 178.886 -56.2461 182.487 -53.6142 185.862C-51.4571 188.628 -49.419 191.242 -45.3662 192.47C-49.5916 192.164 -52.4386 193.872 -55.4517 195.679C-59.1281 197.885 -63.0518 200.238 -70.0283 199.263C-80.1837 197.842 -81.7725 189.702 -81.2974 185.809Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M191.392 258.515C189.803 262.103 184.259 268.294 174.799 264.353C168.3 261.645 166.135 257.627 164.107 253.862C162.444 250.777 160.873 247.862 157.083 245.977C161.198 246.981 164.292 245.77 167.566 244.489C171.561 242.925 175.824 241.257 182.539 243.378C192.314 246.466 192.514 254.756 191.392 258.515Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-71.696 150.221C-69.7749 146.797 -63.6713 141.152 -54.6253 145.959C-48.4108 149.262 -46.6344 153.464 -44.9698 157.402C-43.6056 160.629 -42.3166 163.679 -38.7214 165.909C-42.7233 164.525 -45.9174 165.441 -49.2979 166.411C-53.4227 167.595 -57.8248 168.857 -64.3099 166.118C-73.7499 162.131 -73.1673 153.859 -71.696 150.221Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M172.864 290.683C170.396 293.74 163.43 298.291 155.318 292.048C149.745 287.759 148.699 283.32 147.718 279.161C146.915 275.753 146.155 272.532 142.985 269.736C146.698 271.765 150.002 271.393 153.497 270.998C157.763 270.517 162.315 270.003 168.249 273.782C176.888 279.282 174.925 287.341 172.864 290.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-53.0945 118.317C-50.3484 115.505 -42.9845 111.624 -35.497 118.598C-30.3533 123.388 -29.7303 127.905 -29.1466 132.138C-28.6682 135.606 -28.2162 138.884 -25.3236 141.964C-28.8291 139.596 -32.1528 139.659 -35.6703 139.725C-39.9623 139.806 -44.5429 139.892 -50.0946 135.575C-58.1759 129.292 -55.4617 121.452 -53.0945 118.317Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M146.67 316.964C143.49 319.281 135.578 321.883 129.366 313.763C125.099 308.185 125.242 303.628 125.377 299.358C125.488 295.859 125.592 292.553 123.257 289.035C126.316 291.952 129.603 292.442 133.082 292.962C137.328 293.596 141.858 294.272 146.608 299.45C153.521 306.988 149.53 314.267 146.67 316.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-26.7606 92.2731C-23.3767 90.264 -15.2543 88.412 -9.83568 97.0764C-6.11317 103.029 -6.68619 107.552 -7.2231 111.79C-7.66313 115.264 -8.07892 118.546 -6.08601 122.267C-8.85635 119.077 -12.083 118.281 -15.4979 117.439C-19.6646 116.411 -24.1115 115.315 -28.3514 109.716C-34.5232 101.565 -29.8624 94.6914 -26.7606 92.2731Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M114.594 335.567C110.921 336.986 102.601 337.462 98.7128 328.019C96.0414 321.531 97.3654 317.167 98.606 313.077C99.6227 309.725 100.583 306.558 99.2428 302.559C101.439 306.164 104.487 307.485 107.712 308.883C111.648 310.589 115.849 312.409 119.089 318.634C123.807 327.695 118.058 333.698 114.594 335.567Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M5.51135 73.8631C9.30244 72.794 17.6298 73.0971 20.6103 82.862C22.6579 89.5702 20.928 93.7919 19.307 97.7475C17.9786 100.989 16.7233 104.053 17.6807 108.16C15.8343 104.365 12.9246 102.765 9.84509 101.072C6.0876 99.0066 2.07745 96.802 -0.561752 90.3016C-4.40352 80.8394 1.88625 75.4 5.51135 73.8631Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M78.8233 345.224C74.906 345.648 66.7465 343.966 65.4464 333.843C64.5533 326.888 66.9673 323.013 69.2293 319.383C71.0831 316.407 72.8347 313.595 72.58 309.387C73.7637 313.435 76.3641 315.496 79.1163 317.677C82.4744 320.338 86.0582 323.178 87.5696 330.026C89.7696 339.994 82.6554 344.311 78.8233 345.224Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M41.5218 64.3419C45.4618 64.2857 53.4265 66.7232 53.7658 76.923C53.9989 83.9301 51.23 87.5623 48.6355 90.9657C46.5091 93.7549 44.5 96.3905 44.3566 100.604C43.56 96.4633 41.1655 94.1686 38.6312 91.7402C35.539 88.777 32.2389 85.6147 31.3802 78.656C30.1304 68.5267 37.6205 64.8927 41.5218 64.3419Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M60.2794 144.991C65.9713 136.396 69.2761 126.149 69.2761 115.148C69.2761 104.146 65.9713 93.8991 60.2794 85.3043C54.5875 93.8991 51.2827 104.146 51.2827 115.148C51.2827 126.149 54.5875 136.396 60.2794 144.991Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M60.2794 324.052C65.9713 315.458 69.2761 305.211 69.2761 294.209C69.2761 283.207 65.9713 272.96 60.2794 264.366C54.5875 272.96 51.2827 283.207 51.2827 294.209C51.2827 305.211 54.5875 315.458 60.2794 324.052Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M75.8029 147.025C83.5363 140.189 89.3936 131.142 92.2549 120.516C95.1162 109.889 94.589 99.1399 91.3264 89.3719C83.5931 96.2079 77.7358 105.254 74.8745 115.881C72.0132 126.508 72.5403 137.257 75.8029 147.025Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M29.2325 319.985C36.9659 313.149 42.8231 304.102 45.6844 293.475C48.5458 282.849 48.0186 272.1 44.756 262.332C37.0227 269.168 31.1654 278.214 28.3041 288.841C25.4427 299.468 25.9699 310.217 29.2325 319.985Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M90.2687 152.988C99.5164 148.377 107.527 141.147 113.055 131.619C118.582 122.091 120.869 111.573 120.258 101.297C111.01 105.909 102.999 113.138 97.4718 122.666C91.9442 132.194 89.6578 142.712 90.2687 152.988Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M0.3013 308.059C9.54906 303.448 17.5596 296.218 23.0872 286.691C28.6149 277.163 30.9013 266.645 30.2904 256.369C21.0426 260.98 13.0321 268.21 7.50441 277.738C1.97675 287.265 -0.309631 297.784 0.3013 308.059Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M102.691 162.473C112.823 160.401 122.44 155.481 130.258 147.701C138.075 139.922 143.019 130.351 145.102 120.268C134.97 122.34 125.352 127.26 117.534 135.04C109.717 142.819 104.773 152.39 102.691 162.473Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-24.5426 289.089C-14.4107 287.016 -4.79279 282.096 3.02452 274.317C10.8418 266.538 15.786 256.966 17.8683 246.884C7.73637 248.956 -1.88152 253.876 -9.69882 261.655C-17.5161 269.435 -22.4603 279.006 -24.5426 289.089Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M112.222 174.835C122.548 175.443 133.118 173.167 142.692 167.667C152.266 162.166 159.531 154.194 164.165 144.991C153.839 144.383 143.269 146.659 133.695 152.159C124.121 157.66 116.856 165.632 112.222 174.835Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-43.6058 264.365C-33.2802 264.973 -22.7104 262.698 -13.1362 257.197C-3.562 251.696 3.70299 243.725 8.33672 234.522C-1.98894 233.914 -12.5588 236.189 -22.133 241.69C-31.7071 247.191 -38.9721 255.163 -43.6058 264.365Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M118.214 189.23C128.03 192.477 138.831 193.001 149.51 190.154C160.188 187.307 169.279 181.478 176.148 173.782C166.333 170.535 155.531 170.011 144.853 172.858C134.174 175.706 125.083 181.534 118.214 189.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-55.5897 235.575C-45.774 238.821 -34.9725 239.346 -24.2939 236.499C-13.6153 233.651 -4.52461 227.822 2.34471 220.127C-7.47096 216.88 -18.2724 216.355 -28.951 219.203C-39.6296 222.05 -48.7203 227.879 -55.5897 235.575Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M120.258 204.678C128.895 210.343 139.192 213.631 150.247 213.631C161.302 213.631 171.599 210.343 180.236 204.678C171.599 199.014 161.302 195.725 150.247 195.725C139.192 195.725 128.895 199.014 120.258 204.678Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-59.6769 204.678C-51.0401 210.343 -40.7432 213.631 -29.6879 213.631C-18.6326 213.631 -8.33565 210.343 0.301132 204.678C-8.33566 199.014 -18.6326 195.725 -29.6879 195.725C-40.7432 195.725 -51.0401 199.014 -59.6769 204.678Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M118.214 220.127C125.083 227.822 134.174 233.651 144.853 236.499C155.531 239.346 166.333 238.821 176.148 235.575C169.279 227.879 160.188 222.05 149.51 219.203C138.831 216.355 128.03 216.88 118.214 220.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-55.5896 173.782C-48.7203 181.478 -39.6296 187.307 -28.9509 190.154C-18.2723 193.002 -7.47092 192.477 2.34474 189.23C-4.52458 181.534 -13.6153 175.706 -24.2939 172.858C-34.9725 170.011 -45.7739 170.535 -55.5896 173.782Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M112.2 234.567C116.837 243.755 124.103 251.715 133.677 257.211C143.251 262.706 153.818 264.981 164.141 264.379C159.504 255.191 152.238 247.23 142.664 241.735C133.09 236.24 122.523 233.964 112.2 234.567Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-43.6223 145.129C-38.9859 154.317 -31.7195 162.278 -22.1457 167.773C-12.5719 173.268 -2.00414 175.544 8.31825 174.941C3.68184 165.753 -3.58455 157.792 -13.1584 152.297C-22.7322 146.802 -33.2999 144.526 -43.6223 145.129Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M102.677 246.929C104.765 256.998 109.714 266.559 117.532 274.333C125.351 282.107 134.966 287.027 145.094 289.103C143.005 279.034 138.057 269.473 130.238 261.699C122.42 253.926 112.804 249.006 102.677 246.929Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-24.5752 120.405C-22.4865 130.474 -17.5381 140.035 -9.71962 147.809C-1.90118 155.582 7.71457 160.502 17.8419 162.579C15.7532 152.51 10.8048 142.949 2.98633 135.175C-4.83209 127.401 -14.4478 122.481 -24.5752 120.405Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M90.2623 256.417C89.6609 266.681 91.9541 277.191 97.4844 286.713C103.015 296.236 111.023 303.465 120.265 308.079C120.867 297.815 118.573 287.306 113.043 277.783C107.513 268.26 99.5044 261.031 90.2623 256.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M0.253281 101.429C-0.348053 111.693 1.94514 122.202 7.47537 131.725C13.0056 141.248 21.0141 148.477 30.2562 153.091C30.8575 142.827 28.5643 132.317 23.0341 122.795C17.5039 113.272 9.49541 106.043 0.253281 101.429Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M75.8035 262.384C72.553 272.144 72.0348 282.886 74.8999 293.508C77.7651 304.131 83.6205 313.176 91.3476 320.014C94.598 310.254 95.1162 299.512 92.2511 288.89C89.386 278.267 83.5305 269.222 75.8035 262.384Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M29.1709 89.494C25.9205 99.2536 25.4023 109.996 28.2674 120.618C31.1325 131.241 36.988 140.286 44.7151 147.124C47.9655 137.364 48.4837 126.622 45.6186 116C42.7535 105.377 36.898 96.3316 29.1709 89.494Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M51.105 59.9436C57.1568 66.7823 59.6089 72.5815 60.0785 74.6263C63.3866 66.9498 62.5091 70.3181 69.479 58.8162C75.0549 49.6147 73.9237 40.7689 72.6611 37.4962C71.6237 35.0329 68.6237 29.108 64.9235 25.1144C61.2232 21.1208 59.1498 14.4374 58.5756 11.5949C57.7429 18.239 56.0359 22.6173 52.5022 27.0004C49.6752 30.5069 47.522 36.2112 46.7988 38.625C45.7126 42.8818 45.0531 53.1049 51.105 59.9436Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M51.105 386.432C57.1568 393.271 59.6089 399.07 60.0785 401.115C63.3866 393.438 62.5091 396.807 69.479 385.305C75.0549 376.103 73.9237 367.257 72.6611 363.985C71.6237 361.521 68.6237 355.596 64.9235 351.603C61.2232 347.609 59.1498 340.926 58.5756 338.083C57.7429 344.727 56.0359 349.106 52.5022 353.489C49.6752 356.995 47.522 362.7 46.7988 365.113C45.7126 369.37 45.0531 379.593 51.105 386.432Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M89.5047 62.6398C93.5717 70.8042 94.432 77.0374 94.3538 79.1334C99.5457 72.5706 97.822 75.598 107.546 66.2832C115.325 58.8314 116.533 49.9957 116.164 46.5093C115.803 43.8628 114.446 37.367 111.911 32.5564C109.375 27.7459 109.111 20.7562 109.295 17.8627C106.763 24.0659 103.975 27.8554 99.4222 31.179C95.7796 33.8378 92.2162 38.7932 90.8898 40.9385C88.7335 44.7704 85.4376 54.4754 89.5047 62.6398Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M4.5912 378.003C8.65822 386.168 9.51852 392.401 9.44031 394.497C14.6322 387.934 12.9085 390.962 22.6324 381.647C30.4115 374.195 31.6194 365.359 31.251 361.873C30.8896 359.226 29.5329 352.731 26.9973 347.92C24.4618 343.109 24.1973 336.12 24.3819 333.226C21.8495 339.429 19.062 343.219 14.5087 346.543C10.8661 349.201 7.3027 354.157 5.97633 356.302C3.82002 360.134 0.52417 369.839 4.5912 378.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M125.895 75.1343C127.7 84.068 126.91 90.3104 126.289 92.3149C133.011 87.3129 130.559 89.7932 142.374 83.3003C151.826 78.106 155.291 69.8825 155.841 66.42C156.181 63.7706 156.56 57.1467 155.362 51.847C154.164 46.5473 155.726 39.7277 156.657 36.9803C152.597 42.3199 148.919 45.2623 143.657 47.2999C139.447 48.9299 134.716 52.7986 132.877 54.5292C129.797 57.6752 124.09 66.2006 125.895 75.1343Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-38.1454 357.882C-36.3404 366.815 -37.1305 373.058 -37.7512 375.062C-31.0294 370.06 -33.4817 372.541 -21.6666 366.048C-12.2145 360.853 -8.74971 352.63 -8.19884 349.167C-7.8596 346.518 -7.48065 339.894 -8.67863 334.594C-9.87662 329.295 -8.31427 322.475 -7.38335 319.728C-11.4428 325.067 -15.1209 328.01 -20.3834 330.047C-24.5934 331.677 -29.3242 335.546 -31.1634 337.277C-34.2428 340.423 -39.9505 348.948 -38.1454 357.882Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M157.795 96.5759C157.215 105.67 154.829 111.496 153.708 113.273C161.502 110.172 158.488 111.936 171.589 108.708C182.07 106.125 187.555 99.0742 188.988 95.8716C190.005 93.3998 192.094 87.0993 192.315 81.6716C192.536 76.2439 195.819 70.059 197.432 67.6451C192.123 71.7571 187.805 73.652 182.191 74.2647C177.701 74.7549 172.125 77.2732 169.898 78.4712C166.106 80.7168 158.375 87.4816 157.795 96.5759Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-74.1928 327.438C-74.7728 336.533 -77.1595 342.359 -78.2804 344.135C-70.4866 341.035 -73.5005 342.799 -60.3993 339.57C-49.9184 336.988 -44.4328 329.937 -43.0002 326.734C-41.9835 324.262 -39.8947 317.962 -39.6735 312.534C-39.4523 307.106 -36.1695 300.922 -34.5558 298.508C-39.8656 302.62 -44.1837 304.514 -49.7968 305.127C-54.2873 305.617 -59.8631 308.136 -62.0897 309.334C-65.8824 311.579 -73.6129 318.344 -74.1928 327.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M183.032 125.503C180.107 134.138 176.286 139.151 174.742 140.578C183.076 139.591 179.706 140.519 193.201 140.775C203.996 140.979 211.129 135.581 213.345 132.857C214.97 130.731 218.627 125.183 220.252 119.998C221.877 114.812 226.657 109.683 228.843 107.767C222.645 110.372 217.981 111.09 212.4 110.236C207.935 109.553 201.894 110.549 199.432 111.133C195.184 112.325 185.958 116.868 183.032 125.503Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-101.094 288.748C-104.02 297.383 -107.84 302.396 -109.385 303.823C-101.05 302.835 -104.42 303.763 -90.926 304.019C-80.1304 304.224 -72.998 298.826 -70.7812 296.102C-69.1563 293.976 -65.5 288.428 -63.8747 283.242C-62.2494 278.056 -57.4699 272.928 -55.2833 271.012C-61.4817 273.616 -66.1454 274.334 -71.7267 273.48C-76.1917 272.797 -82.2325 273.794 -84.6947 274.377C-88.9423 275.569 -98.1687 280.113 -101.094 288.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M199.886 159.945C194.814 167.532 189.82 171.39 187.957 172.371C196.264 173.564 192.768 173.592 205.736 177.315C216.11 180.293 224.404 176.916 227.253 174.856C229.376 173.221 234.35 168.804 237.269 164.213C240.188 159.623 246.138 155.9 248.749 154.613C242.084 155.532 237.392 155.024 232.223 152.762C228.088 150.952 221.994 150.359 219.464 150.288C215.051 150.346 204.957 152.358 199.886 159.945Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-117.016 244.447C-122.088 252.034 -127.082 255.892 -128.945 256.873C-120.638 258.066 -124.134 258.094 -111.166 261.817C-100.792 264.795 -92.4984 261.418 -89.6486 259.357C-87.5261 257.723 -82.5515 253.306 -79.6329 248.715C-76.7143 244.125 -70.7638 240.402 -68.1534 239.114C-74.8179 240.033 -79.5095 239.526 -84.6784 237.263C-88.8136 235.454 -94.9077 234.86 -97.4379 234.79C-101.851 234.847 -111.944 236.859 -117.016 244.447Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M207.207 197.554C200.335 203.577 194.508 206.017 192.453 206.484C200.167 209.776 196.782 208.903 208.34 215.839C217.587 221.388 226.476 220.262 229.764 219.006C232.24 217.973 238.194 214.988 242.207 211.306C246.22 207.623 252.936 205.56 255.792 204.989C249.116 204.16 244.716 202.461 240.311 198.945C236.788 196.131 231.056 193.989 228.63 193.269C224.353 192.188 214.08 191.532 207.207 197.554Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-120.874 197.554C-127.746 203.577 -133.573 206.017 -135.628 206.484C-127.914 209.777 -131.299 208.903 -119.741 215.839C-110.494 221.388 -101.605 220.262 -98.3167 219.006C-95.8414 217.974 -89.8875 214.988 -85.8744 211.306C-81.8613 207.624 -75.1454 205.56 -72.289 204.989C-78.9655 204.16 -83.3652 202.462 -87.7697 198.945C-91.2932 196.132 -97.0253 193.989 -99.451 193.269C-103.728 192.188 -114.002 191.532 -120.874 197.554Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M204.498 235.768C196.294 239.815 190.03 240.671 187.924 240.593C194.519 245.76 191.477 244.045 200.837 253.721C208.325 261.463 217.204 262.665 220.707 262.298C223.367 261.938 229.894 260.588 234.728 258.065C239.562 255.542 246.586 255.279 249.494 255.462C243.26 252.942 239.452 250.168 236.112 245.637C233.441 242.012 228.461 238.466 226.305 237.146C222.455 235 212.702 231.72 204.498 235.768Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-112.404 151.267C-120.608 155.314 -126.872 156.17 -128.978 156.092C-122.383 161.259 -125.425 159.543 -116.065 169.22C-108.577 176.961 -99.698 178.163 -96.1946 177.797C-93.5351 177.437 -87.0077 176.087 -82.1736 173.564C-77.3396 171.041 -70.3158 170.777 -67.4082 170.961C-73.6416 168.441 -77.4497 165.667 -80.7894 161.136C-83.4613 157.511 -88.4408 153.965 -90.5965 152.645C-94.4472 150.499 -104.2 147.219 -112.404 151.267Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M191.943 271.981C182.965 273.777 176.693 272.991 174.678 272.373C179.705 279.063 177.212 276.622 183.737 288.38C188.957 297.786 197.22 301.234 200.699 301.782C203.362 302.12 210.018 302.497 215.344 301.305C220.669 300.113 227.522 301.667 230.283 302.594C224.917 298.554 221.96 294.894 219.913 289.657C218.275 285.467 214.387 280.76 212.648 278.929C209.487 275.865 200.92 270.185 191.943 271.981Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-92.1838 108.737C-101.161 110.533 -107.434 109.747 -109.448 109.129C-104.422 115.819 -106.914 113.378 -100.39 125.136C-95.17 134.542 -86.9064 137.99 -83.427 138.538C-80.7646 138.876 -74.1084 139.253 -68.7829 138.061C-63.4573 136.869 -56.6044 138.424 -53.8437 139.35C-59.2093 135.31 -62.1661 131.65 -64.2136 126.413C-65.8516 122.223 -69.7391 117.516 -71.4782 115.685C-74.6395 112.621 -83.2065 106.941 -92.1838 108.737Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M170.397 303.727C161.258 303.15 155.403 300.775 153.618 299.659C156.734 307.415 154.961 304.416 158.205 317.453C160.801 327.883 167.886 333.342 171.104 334.768C173.588 335.78 179.919 337.858 185.374 338.079C190.828 338.299 197.043 341.566 199.469 343.171C195.336 337.887 193.432 333.59 192.817 328.004C192.324 323.536 189.793 317.987 188.59 315.771C186.333 311.997 179.535 304.304 170.397 303.727Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-61.5919 72.8649C-70.7305 72.2878 -76.585 69.9126 -78.37 68.7972C-75.2546 76.5531 -77.0274 73.5539 -73.7832 86.5915C-71.1878 97.0216 -64.1024 102.48 -60.8842 103.906C-58.4003 104.918 -52.0691 106.997 -46.6149 107.217C-41.1607 107.437 -34.9457 110.704 -32.52 112.31C-36.6521 107.025 -38.5562 102.728 -39.1719 97.1425C-39.6644 92.6738 -42.1951 87.1251 -43.3989 84.9093C-45.6555 81.135 -52.4533 73.4421 -61.5919 72.8649Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M141.328 328.841C132.651 325.93 127.614 322.128 126.18 320.591C127.172 328.885 126.239 325.531 125.982 338.96C125.776 349.703 131.201 356.801 133.938 359.007C136.074 360.624 141.649 364.263 146.86 365.88C152.071 367.497 157.225 372.254 159.151 374.43C156.533 368.261 155.812 363.62 156.67 358.066C157.356 353.623 156.355 347.611 155.769 345.161C154.57 340.934 150.005 331.753 141.328 328.841Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-22.7125 46.0943C-31.3896 43.1831 -36.427 39.381 -37.861 37.8438C-36.869 46.1378 -37.8013 42.7842 -38.0584 56.2131C-38.2641 66.9563 -32.84 74.0541 -30.1022 76.2601C-27.9661 77.8772 -22.3912 81.5157 -17.1802 83.1331C-11.9691 84.7505 -6.81548 89.5068 -4.89006 91.6828C-7.50708 85.5145 -8.22871 80.8734 -7.37064 75.3192C-6.68417 70.8759 -7.6855 64.8645 -8.27197 62.4142C-9.47003 58.1872 -14.0355 49.0056 -22.7125 46.0943Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M106.718 345.613C99.0939 340.566 95.2171 335.596 94.2317 333.742C93.0328 342.009 93.0044 338.529 89.2634 351.435C86.2706 361.759 89.6639 370.012 91.7347 372.848C93.3774 374.96 97.8161 379.91 102.429 382.815C107.042 385.719 110.783 391.641 112.077 394.239C111.153 387.606 111.663 382.938 113.936 377.794C115.755 373.679 116.351 367.614 116.422 365.096C116.364 360.705 114.342 350.66 106.718 345.613Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M21.8044 30.2498C14.1801 25.2028 10.3033 20.2328 9.31793 18.3787C8.11902 26.6456 8.09067 23.1661 4.34969 36.0713C1.35689 46.3954 4.75018 54.6484 6.82095 57.4844C8.46367 59.5965 12.9023 64.5469 17.5152 67.4514C22.128 70.3559 25.869 76.2775 27.1629 78.8752C26.2393 72.2431 26.7493 67.5743 29.0227 62.4304C30.8414 58.3153 31.4377 52.2507 31.5084 49.7329C31.4505 45.3414 29.4287 35.2967 21.8044 30.2498Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M93.9358 24.6681C85.9868 31.2967 83.2093 37.7061 82.8142 40.0823C82.3983 36.6711 80.4032 28.6084 75.7509 23.6464C71.0986 18.6844 68.7151 10.7361 67.8985 7.43702C67.6585 4.751 69.8393 0.452911 73.6409 1.17902C77.4426 1.90512 78.057 5.79416 77.8889 7.64791C77.6575 9.17525 77.3398 13.0497 77.9202 16.3288C78.5006 19.6079 79.8888 23.8081 80.5104 25.4984C81.2703 27.7808 82.7951 33.893 82.8142 40.0823C83.5542 33.8871 87.7295 26.06 89.7247 22.9208C90.3265 22.0929 91.9194 19.7946 93.4762 17.2255C95.0329 14.6563 95.6412 10.9128 95.7507 9.36221C96.2326 7.19123 98.1763 3.07416 102.096 3.9737C106.016 4.87323 105.863 9.65932 105.297 11.9399C104.822 13.4207 101.885 18.0395 93.9358 24.6681Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M89.926 15.9817C86.0652 22.6368 83.7903 31.0909 83.1355 34.4861C83.8076 27.0711 82.6113 23.4481 81.7585 17.0619C81.0761 11.9529 81.615 8.04527 81.8722 6.71145L82.2884 5.47085C85.3457 0.623554 89.0492 1.85893 90.5187 3.08254C91.9298 4.60928 93.7868 9.32655 89.926 15.9817Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M26.2612 395.654C34.113 388.911 36.797 382.463 37.1575 380.081C37.623 383.486 39.7351 391.519 44.459 396.413C49.183 401.308 51.6819 409.221 52.5464 412.508C52.8254 415.19 50.7073 419.519 46.8955 418.848C43.0837 418.177 42.4128 414.297 42.5539 412.441C42.763 410.911 43.0244 407.032 42.3963 403.762C41.7683 400.491 40.3192 396.311 39.6732 394.63C38.8801 392.359 37.2666 386.269 37.1575 380.081C36.5077 386.286 32.4466 394.173 30.4973 397.34C29.9075 398.177 28.3482 400.498 26.829 403.089C25.3098 405.68 24.756 409.432 24.669 410.984C24.2188 413.162 22.3351 417.306 18.4026 416.463C14.4702 415.62 14.553 410.833 15.086 408.544C15.5395 407.057 18.4094 402.396 26.2612 395.654Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M30.3969 404.281C34.1606 397.571 36.3122 389.085 36.9176 385.681C36.3534 393.105 37.6022 396.711 38.5479 403.084C39.3044 408.182 38.8224 412.097 38.5846 413.435L38.1865 414.681C35.2 419.572 31.479 418.39 29.9918 417.188C28.5586 415.682 26.6333 410.991 30.3969 404.281Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M140.985 39.6605C131.583 44.0159 127.233 49.4916 126.234 51.685C126.719 48.2829 126.889 39.9811 123.686 33.9899C120.482 27.9987 120.247 19.7073 120.316 16.3103C120.783 13.654 124.008 10.0641 127.491 11.7446C130.974 13.4252 130.556 17.3399 129.912 19.0872C129.291 20.5029 127.976 24.1635 127.684 27.4804C127.392 30.7972 127.64 35.2119 127.801 37.0046C127.942 39.405 127.825 45.7017 126.234 51.685C128.56 45.8916 134.628 39.4065 137.372 36.8882C138.169 36.2435 140.305 34.4338 142.477 32.3531C144.649 30.2725 146.21 26.8132 146.719 25.3436C147.749 23.3708 150.697 19.8946 154.25 21.7731C157.802 23.6516 156.41 28.2353 155.27 30.2924C154.426 31.6003 150.387 35.3051 140.985 39.6605Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M139.371 30.2373C133.911 35.6712 129.515 43.2514 127.999 46.3622C130.577 39.373 130.364 35.5653 131.201 29.1771C131.871 24.0665 133.407 20.4307 134.003 19.2086L134.727 18.1175C138.941 14.2228 142.197 16.37 143.299 17.9304C144.264 19.7685 144.831 24.8034 139.371 30.2373Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-20.8702 380.575C-11.5324 376.084 -7.26268 370.547 -6.29504 368.339C-6.73091 371.748 -6.78011 380.051 -3.49005 385.996C-0.199997 391.94 0.155609 400.227 0.135757 403.625C-0.292343 406.288 -3.46416 409.923 -6.9715 408.293C-10.4788 406.663 -10.1178 402.743 -9.49883 400.986C-8.89873 399.562 -7.63753 395.883 -7.3936 392.562C-7.14966 389.241 -7.46227 384.831 -7.64906 383.04C-7.82442 380.642 -7.79909 374.345 -6.29504 368.339C-8.53659 374.165 -14.5104 380.737 -17.2171 383.295C-18.0043 383.951 -20.1142 385.791 -22.2555 387.903C-24.3969 390.014 -25.9077 393.496 -26.3954 394.973C-27.3966 396.96 -30.294 400.478 -33.8733 398.651C-37.4525 396.824 -36.1273 392.221 -35.0173 390.147C-34.1923 388.828 -30.208 385.065 -20.8702 380.575Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-19.1194 389.974C-13.7388 384.462 -9.45343 376.819 -7.98329 373.687C-10.4591 380.712 -10.1905 384.517 -10.9346 390.916C-11.53 396.036 -13.0137 399.693 -13.5913 400.924L-14.3 402.025C-18.4568 405.98 -21.7436 403.88 -22.8674 402.336C-23.86 400.512 -24.4999 395.486 -19.1194 389.974Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M182.533 66.2786C172.318 68.064 166.693 72.2327 165.157 74.0939C166.51 70.9328 168.833 62.9576 167.298 56.3455C165.762 49.7334 167.691 41.664 168.641 38.4006C169.783 35.9551 173.831 33.3179 176.759 35.8383C179.686 38.3588 178.264 42.0325 177.187 43.5542C176.22 44.7618 173.998 47.9591 172.853 51.0877C171.708 54.2162 170.8 58.5445 170.489 60.3175C170 62.6723 168.25 68.7243 165.157 74.0939C168.91 69.097 176.459 64.396 179.764 62.6701C180.701 62.2526 183.235 61.0548 185.874 59.6045C188.513 58.1541 190.921 55.2148 191.795 53.9264C193.303 52.2861 197.055 49.6877 199.998 52.4171C202.94 55.1465 200.403 59.2156 198.767 60.9089C197.612 61.9549 192.747 64.4933 182.533 66.2786Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M183.425 56.7608C176.737 60.6033 170.52 66.7929 168.247 69.4073C172.554 63.3202 173.339 59.5873 175.809 53.6323C177.785 48.8684 180.215 45.7523 181.108 44.7252L182.091 43.8579C187.174 41.1813 189.761 44.0939 190.419 45.8848C190.874 47.9091 190.112 52.9183 183.425 56.7608Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-62.4728 353.888C-52.2854 351.956 -46.7209 347.707 -45.2121 345.824C-46.5196 349.004 -48.7267 357.012 -47.0948 363.601C-45.4629 370.19 -47.2747 378.287 -48.1775 381.564C-49.2836 384.025 -53.293 386.72 -56.2568 384.242C-59.2207 381.764 -57.8523 378.071 -56.7976 376.533C-55.8475 375.312 -53.6724 372.083 -52.5731 368.938C-51.4738 365.794 -50.6287 361.453 -50.3435 359.675C-49.8891 357.314 -48.2268 351.237 -45.2121 345.824C-48.8925 350.874 -56.372 355.683 -59.6516 357.457C-60.5827 357.888 -63.0992 359.122 -65.7169 360.61C-68.3345 362.098 -70.6992 365.072 -71.5543 366.373C-73.0384 368.035 -76.7521 370.687 -79.7342 368C-82.7162 365.313 -80.239 361.208 -78.6276 359.491C-77.4874 358.429 -72.6603 355.821 -62.4728 353.888Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-63.2262 363.418C-56.5954 359.48 -50.4683 353.201 -48.2336 350.554C-52.4523 356.703 -53.1822 360.447 -55.5654 366.437C-57.472 371.228 -59.8565 374.379 -60.7344 375.419L-61.7054 376.3C-66.7491 379.05 -69.3778 376.175 -70.0616 374.394C-70.546 372.376 -69.8569 367.356 -63.2262 363.418Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M215.748 102.708C205.417 101.802 198.899 104.38 196.931 105.782C199.061 103.077 203.379 95.9721 203.615 89.1897C203.851 82.4073 207.813 75.1098 209.58 72.2024C211.319 70.1342 215.915 68.6296 218.087 71.8181C220.26 75.0067 217.931 78.189 216.495 79.3815C215.246 80.2987 212.268 82.8148 210.349 85.5419C208.429 88.2689 206.426 92.2158 205.665 93.8483C204.58 95.997 201.315 101.392 196.931 105.782C201.856 101.922 210.37 99.3254 214.012 98.5096C215.025 98.3477 217.785 97.8435 220.711 97.1222C223.637 96.401 226.728 94.182 227.907 93.1626C229.79 91.9666 234.09 90.4231 236.222 93.8174C238.355 97.2118 234.846 100.489 232.826 101.703C231.437 102.416 226.079 103.615 215.748 102.708Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M219.085 93.7445C211.626 95.7337 204.01 100.111 201.135 102.051C206.879 97.2806 208.607 93.8769 212.542 88.7611C215.689 84.6684 218.847 82.2844 219.977 81.5223L221.153 80.9379C226.759 79.6617 228.5 83.1413 228.669 85.0406C228.582 87.1131 226.543 91.7554 219.085 93.7445Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-95.7115 317.414C-85.3687 318.171 -78.8886 315.5 -76.9414 314.07C-79.0315 316.805 -83.2461 323.971 -83.3836 330.756C-83.521 337.541 -87.3768 344.895 -89.1011 347.828C-90.8097 349.921 -95.3835 351.491 -97.6018 348.334C-99.8202 345.178 -97.5378 341.962 -96.1193 340.749C-94.8838 339.814 -91.9431 337.255 -90.0634 334.501C-88.1837 331.746 -86.2383 327.771 -85.5006 326.128C-84.4475 323.964 -81.2614 318.522 -76.9414 314.07C-81.81 318 -90.2854 320.719 -93.9145 321.587C-94.9259 321.764 -97.6777 322.307 -100.593 323.071C-103.509 323.834 -106.566 326.097 -107.731 327.134C-109.596 328.357 -113.873 329.962 -116.055 326.599C-118.237 323.235 -114.776 319.908 -112.773 318.665C-111.395 317.932 -106.054 316.656 -95.7115 317.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-98.9177 326.425C-91.4886 324.328 -83.9373 319.842 -81.0903 317.861C-86.7644 322.713 -88.4432 326.141 -92.3031 331.313C-95.391 335.451 -98.5136 337.88 -99.632 338.659L-100.799 339.26C-106.386 340.617 -108.178 337.162 -108.375 335.266C-108.318 333.192 -106.347 328.521 -98.9177 326.425Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M238.366 146.467C228.623 142.931 221.656 143.742 219.391 144.589C222.152 142.525 228.171 136.775 230.163 130.284C232.155 123.794 237.88 117.765 240.343 115.412C242.56 113.862 247.391 113.593 248.66 117.232C249.929 120.871 246.852 123.345 245.154 124.128C243.71 124.692 240.179 126.355 237.616 128.495C235.052 130.635 232.091 133.931 230.931 135.312C229.325 137.108 224.768 141.478 219.391 144.589C225.152 142.13 234.052 141.814 237.781 141.964C238.803 142.069 241.599 142.293 244.613 142.35C247.627 142.407 251.189 141.059 252.594 140.378C254.724 139.708 259.278 139.325 260.456 143.153C261.633 146.981 257.391 149.242 255.124 149.895C253.597 150.226 248.109 150.003 238.366 146.467Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M243.921 138.668C236.199 138.668 227.704 140.935 224.422 142.068C231.211 138.94 233.766 136.097 238.897 132.169C243.002 129.027 246.672 127.537 247.961 127.092L249.249 126.831C254.996 127.042 255.772 130.851 255.442 132.729C254.819 134.709 251.643 138.668 243.921 138.668Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-118.321 273.636C-108.528 277.032 -101.574 276.121 -99.321 275.241C-102.051 277.344 -107.986 283.181 -109.883 289.7C-111.781 296.218 -117.418 302.328 -119.846 304.717C-122.041 306.298 -126.867 306.637 -128.189 303.017C-129.511 299.396 -126.47 296.878 -124.784 296.071C-123.348 295.486 -119.842 293.772 -117.31 291.596C-114.777 289.419 -111.865 286.081 -110.725 284.683C-109.145 282.864 -104.652 278.429 -99.321 275.241C-105.046 277.783 -113.94 278.227 -117.671 278.13C-118.694 278.04 -121.493 277.857 -124.508 277.843C-127.523 277.83 -131.064 279.228 -132.459 279.929C-134.579 280.63 -139.128 281.079 -140.36 277.269C-141.593 273.458 -137.385 271.135 -135.127 270.451C-133.606 270.098 -128.115 270.241 -118.321 273.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-123.762 281.514C-116.041 281.403 -107.58 279.014 -104.314 277.834C-111.057 281.06 -113.57 283.939 -118.644 287.94C-122.703 291.142 -126.351 292.684 -127.634 293.147L-128.917 293.428C-134.667 293.299 -135.499 289.501 -135.196 287.618C-134.602 285.63 -131.483 281.626 -123.762 281.514Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M248.847 194.573C240.355 188.648 233.415 187.637 231.007 187.872C234.21 186.589 241.52 182.585 245.132 176.828C248.744 171.072 255.842 166.724 258.833 165.085C261.378 164.159 266.114 165.143 266.393 168.985C266.673 172.827 263.057 174.425 261.214 174.743C259.672 174.916 255.829 175.613 252.796 177.02C249.763 178.426 246.046 180.848 244.566 181.883C242.547 183.204 237.009 186.251 231.007 187.872C237.211 186.98 245.889 188.967 249.453 190.073C250.412 190.437 253.055 191.373 255.952 192.205C258.849 193.036 262.64 192.652 264.173 192.356C266.405 192.257 270.904 193.06 271.046 197.061C271.187 201.061 266.502 202.154 264.142 202.2C262.582 202.126 257.338 200.498 248.847 194.573Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M256.24 188.47C248.781 186.482 239.987 186.483 236.522 186.732C243.893 185.459 247.1 183.372 253.078 180.899C257.86 178.921 261.793 178.427 263.154 178.329L264.466 178.408C269.962 180.093 269.721 183.972 268.914 185.701C267.797 187.453 263.699 190.459 256.24 188.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-128.761 225.54C-120.185 231.342 -113.231 232.253 -110.826 231.983C-114.01 233.312 -121.261 237.421 -124.789 243.229C-128.317 249.036 -135.351 253.486 -138.318 255.168C-140.849 256.13 -145.599 255.215 -145.934 251.377C-146.269 247.539 -142.677 245.89 -140.839 245.545C-139.299 245.35 -135.467 244.598 -132.455 243.148C-129.443 241.698 -125.761 239.223 -124.296 238.167C-122.297 236.816 -116.804 233.689 -110.826 231.983C-117.017 232.964 -125.723 231.102 -129.302 230.048C-130.266 229.698 -132.923 228.799 -135.831 228.01C-138.739 227.22 -142.525 227.659 -144.054 227.977C-146.284 228.108 -150.794 227.37 -150.994 223.372C-151.193 219.373 -146.525 218.214 -144.165 218.134C-142.604 218.185 -137.338 219.737 -128.761 225.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-136.065 231.748C-128.578 233.629 -119.784 233.501 -116.323 233.202C-123.675 234.581 -126.852 236.714 -132.793 239.273C-137.546 241.32 -141.471 241.87 -142.831 241.987L-144.143 241.927C-149.664 240.322 -149.48 236.44 -148.697 234.699C-147.606 232.931 -143.552 229.867 -136.065 231.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M246.475 243.747C239.814 235.837 233.374 233.073 230.986 232.68C234.414 232.266 242.516 230.28 247.502 225.65C252.488 221.021 260.475 218.649 263.79 217.836C266.489 217.597 270.809 219.768 270.079 223.551C269.349 227.334 265.441 227.945 263.578 227.778C262.044 227.548 258.15 227.232 254.855 227.809C251.56 228.387 247.339 229.768 245.641 230.387C243.347 231.143 237.205 232.66 230.986 232.68C237.211 233.416 245.077 237.571 248.231 239.556C249.063 240.155 251.372 241.741 253.954 243.29C256.536 244.839 260.298 245.444 261.856 245.553C264.037 246.033 268.174 247.967 267.271 251.868C266.367 255.769 261.557 255.617 259.265 255.053C257.777 254.581 253.136 251.657 246.475 243.747Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M255.204 239.757C248.516 235.915 240.021 233.651 236.609 232.999C244.06 233.668 247.701 232.478 254.119 231.629C259.252 230.95 263.179 231.486 264.519 231.742L265.766 232.156C270.637 235.199 269.396 238.884 268.166 240.347C266.632 241.751 261.892 243.599 255.204 239.757Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-126.32 176.401C-119.545 184.215 -113.064 186.885 -110.671 187.244C-114.093 187.708 -122.165 189.809 -127.083 194.51C-132.002 199.211 -139.953 201.698 -143.256 202.558C-145.952 202.836 -150.302 200.728 -149.627 196.935C-148.953 193.142 -145.054 192.474 -143.189 192.614C-141.651 192.823 -137.754 193.083 -134.467 192.458C-131.181 191.833 -126.981 190.391 -125.291 189.748C-123.009 188.958 -116.89 187.353 -110.671 187.244C-116.907 186.598 -124.831 182.556 -128.014 180.616C-128.855 180.029 -131.187 178.478 -133.791 176.966C-136.395 175.454 -140.165 174.903 -141.725 174.816C-143.913 174.368 -148.078 172.494 -147.231 168.58C-146.384 164.667 -141.573 164.749 -139.273 165.28C-137.778 165.731 -133.095 168.587 -126.32 176.401Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-134.99 180.516C-128.247 184.262 -119.72 186.403 -116.299 187.006C-123.759 186.444 -127.382 187.687 -133.786 188.628C-138.91 189.381 -142.844 188.901 -144.188 188.664L-145.44 188.268C-150.355 185.296 -149.167 181.593 -147.959 180.113C-146.445 178.687 -141.732 176.771 -134.99 180.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M231.41 290.568C227.033 281.211 221.531 276.883 219.327 275.888C222.745 276.371 231.087 276.54 237.108 273.352C243.128 270.165 251.46 269.931 254.874 270C257.543 270.464 261.15 273.673 259.462 277.139C257.773 280.605 253.839 280.19 252.083 279.548C250.661 278.93 246.982 277.622 243.649 277.332C240.316 277.041 235.88 277.288 234.078 277.448C231.666 277.588 225.339 277.471 219.327 275.888C225.148 278.203 231.665 284.242 234.196 286.972C234.843 287.765 236.662 289.891 238.753 292.052C240.844 294.214 244.32 295.767 245.796 296.274C247.779 297.299 251.272 300.233 249.384 303.768C247.497 307.303 242.891 305.918 240.824 304.783C239.509 303.943 235.786 299.924 231.41 290.568Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M240.879 288.962C235.418 283.528 227.801 279.153 224.675 277.645C231.699 280.21 235.525 279.998 241.944 280.831C247.08 281.498 250.733 283.027 251.961 283.619L253.058 284.341C256.971 288.534 254.814 291.774 253.246 292.87C251.399 293.831 246.339 294.395 240.879 288.962Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-111.167 129.498C-106.655 138.791 -101.09 143.04 -98.872 144.003C-102.297 143.569 -110.641 143.52 -116.615 146.794C-122.588 150.068 -130.916 150.422 -134.33 150.402C-137.006 149.976 -140.659 146.82 -139.021 143.33C-137.383 139.839 -133.444 140.199 -131.679 140.815C-130.247 141.412 -126.55 142.667 -123.213 142.91C-119.876 143.152 -115.444 142.841 -113.645 142.655C-111.235 142.481 -104.907 142.506 -98.872 144.003C-104.727 141.772 -111.331 135.827 -113.901 133.134C-114.56 132.35 -116.409 130.251 -118.531 128.12C-120.653 125.989 -124.152 124.485 -125.635 124C-127.633 123.004 -131.168 120.12 -129.332 116.558C-127.496 112.997 -122.87 114.315 -120.787 115.42C-119.46 116.241 -115.68 120.206 -111.167 129.498Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-120.612 131.241C-115.073 136.595 -107.393 140.86 -104.246 142.323C-111.306 139.859 -115.128 140.126 -121.559 139.386C-126.704 138.793 -130.379 137.317 -131.616 136.742L-132.723 136.037C-136.697 131.9 -134.587 128.629 -133.035 127.511C-131.202 126.523 -126.151 125.886 -120.612 131.241Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M204.662 331.914C202.868 321.749 198.679 316.151 196.808 314.622C199.985 315.969 207.999 318.281 214.643 316.753C221.288 315.224 229.396 317.144 232.676 318.09C235.133 319.226 237.783 323.255 235.25 326.168C232.718 329.081 229.026 327.666 227.497 326.594C226.283 325.631 223.071 323.42 219.927 322.281C216.783 321.142 212.434 320.238 210.652 319.928C208.286 319.442 202.204 317.7 196.808 314.622C201.83 318.357 206.553 325.869 208.288 329.158C208.707 330.091 209.911 332.613 211.368 335.239C212.826 337.865 215.78 340.261 217.074 341.131C218.723 342.632 221.334 346.365 218.591 349.294C215.848 352.222 211.759 349.698 210.058 348.07C209.007 346.92 206.456 342.079 204.662 331.914Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M214.226 332.801C210.365 326.146 204.145 319.959 201.518 317.697C207.635 321.984 211.386 322.764 217.37 325.222C222.157 327.189 225.288 329.607 226.32 330.496L227.192 331.475C229.881 336.533 226.955 339.107 225.155 339.762C223.121 340.214 218.087 339.456 214.226 332.801Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-84.3511 88.0977C-82.4094 98.2357 -78.1394 103.773 -76.2471 105.275C-79.4428 103.974 -87.4897 101.777 -94.1111 103.401C-100.733 105.025 -108.868 103.222 -112.161 102.324C-114.635 101.223 -117.343 97.233 -114.853 94.2836C-112.363 91.3341 -108.651 92.6958 -107.107 93.7454C-105.879 94.6909 -102.635 96.8555 -99.4744 97.9494C-96.3144 99.0433 -91.9523 99.8844 -90.1663 100.168C-87.7932 100.62 -81.687 102.275 -76.2471 105.275C-81.3221 101.612 -86.1548 94.169 -87.9367 90.9053C-88.3698 89.9787 -89.6099 87.4744 -91.1054 84.8694C-92.6009 82.2645 -95.5891 79.9113 -96.8962 79.0603C-98.5662 77.5834 -101.231 73.8878 -98.5314 70.9202C-95.8316 67.9526 -91.7064 70.4178 -89.9813 72.0214C-88.9136 73.156 -86.2927 77.9597 -84.3511 88.0977Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-93.9272 87.3481C-89.9697 93.9466 -83.6605 100.044 -81.0007 102.268C-87.1792 98.0696 -90.9413 97.3432 -96.9604 94.9716C-101.776 93.0743 -104.942 90.7014 -105.987 89.8277L-106.872 88.8614C-109.635 83.8422 -106.746 81.2263 -104.956 80.5457C-102.929 80.0638 -97.8848 80.7495 -93.9272 87.3481Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M168.054 364.967C168.965 354.687 166.375 348.2 164.966 346.242C167.684 348.361 174.824 352.659 181.639 352.894C188.454 353.129 195.788 357.072 198.709 358.83C200.788 360.56 202.299 365.134 199.095 367.296C195.891 369.457 192.693 367.14 191.495 365.711C190.573 364.468 188.045 361.505 185.305 359.595C182.564 357.684 178.598 355.691 176.958 354.933C174.798 353.854 169.377 350.605 164.966 346.242C168.845 351.143 171.454 359.616 172.274 363.24C172.436 364.249 172.943 366.995 173.668 369.907C174.393 372.819 176.622 375.894 177.647 377.067C178.849 378.942 180.4 383.221 176.989 385.343C173.578 387.465 170.285 383.973 169.065 381.962C168.348 380.581 167.144 375.248 168.054 364.967Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M177.062 368.288C175.063 360.865 170.665 353.287 168.715 350.425C173.509 356.141 176.929 357.861 182.07 361.777C186.182 364.909 188.578 368.052 189.344 369.176L189.931 370.346C191.213 375.925 187.717 377.657 185.808 377.826C183.726 377.74 179.061 375.711 177.062 368.288Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-47.6985 55.0202C-48.4597 65.3129 -45.7754 71.7615 -44.338 73.6992C-47.0865 71.6192 -54.2879 67.4251 -61.1061 67.2884C-67.9243 67.1516 -75.314 63.3145 -78.2608 61.5986C-80.364 59.8982 -81.9424 55.3467 -78.77 53.1391C-75.5977 50.9315 -72.3665 53.2029 -71.1475 54.6145C-70.2078 55.8439 -67.6367 58.7704 -64.8688 60.641C-62.1009 62.5116 -58.1063 64.4475 -56.4549 65.1816C-54.2803 66.2296 -48.8124 69.4002 -44.338 73.6992C-48.2876 68.8542 -51.0198 60.42 -51.8921 56.8086C-52.0695 55.802 -52.6161 53.0636 -53.3831 50.1623C-54.1501 47.2609 -56.4244 44.2182 -57.4657 43.0596C-58.6947 41.2029 -60.3078 36.9467 -56.9281 34.7756C-53.5484 32.6046 -50.205 36.0483 -48.9557 38.0416C-48.2195 39.4125 -46.9373 44.7275 -47.6985 55.0202Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-56.7534 51.8296C-54.6468 59.2227 -50.1385 66.7373 -48.1477 69.5704C-53.0238 63.9239 -56.4687 62.2533 -61.6659 58.4122C-65.8237 55.3392 -68.2647 52.2318 -69.0469 51.1188L-69.651 49.9572C-71.0144 44.3974 -67.5435 42.6147 -65.6376 42.4184C-63.5539 42.475 -58.8599 44.4366 -56.7534 51.8296Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M124.082 387.476C127.636 377.78 126.821 370.848 125.969 368.593C128.043 371.34 133.822 377.33 140.344 379.313C146.866 381.295 152.924 386.992 155.289 389.443C156.846 391.65 157.117 396.457 153.46 397.72C149.803 398.983 147.317 395.921 146.531 394.232C145.964 392.794 144.292 389.28 142.142 386.729C139.992 384.178 136.679 381.231 135.292 380.077C133.487 378.478 129.095 373.944 125.969 368.593C128.441 374.327 128.758 383.183 128.607 386.894C128.502 387.91 128.277 390.693 128.22 393.693C128.162 396.692 129.516 400.237 130.201 401.634C130.874 403.754 131.259 408.287 127.413 409.458C123.566 410.63 121.293 406.409 120.638 404.152C120.305 402.633 120.529 397.172 124.082 387.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M131.919 393.004C131.919 385.319 129.641 376.866 128.503 373.6C131.646 380.356 134.502 382.898 138.45 388.004C141.608 392.089 143.104 395.741 143.552 397.025L143.815 398.306C143.602 404.025 139.774 404.798 137.887 404.47C135.898 403.849 131.919 400.688 131.919 393.004Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-3.70753 32.5201C-7.11975 42.266 -6.20403 49.1863 -5.31964 51.4282C-7.43349 48.7112 -13.2987 42.8052 -19.849 40.9169C-26.3993 39.0287 -32.5393 33.419 -34.9394 31.0026C-36.5287 28.8185 -36.8695 24.0155 -33.2311 22.7002C-29.5927 21.3849 -27.0623 24.4111 -26.252 26.0886C-25.6641 27.5182 -23.9417 31.0072 -21.7546 33.5269C-19.5676 36.0467 -16.2125 38.9455 -14.8084 40.0799C-12.9804 41.6523 -8.52341 46.1232 -5.31964 51.4282C-7.87456 45.731 -8.32002 36.8805 -8.2234 33.1674C-8.13297 32.1495 -7.94867 29.3636 -7.93497 26.3636C-7.92126 23.3635 -9.32675 19.8387 -10.0312 18.4514C-10.7354 16.3414 -11.1866 11.8148 -7.35742 10.5882C-3.52823 9.36154 -1.19438 13.5491 -0.506119 15.7962C-0.151505 17.31 -0.295334 22.7742 -3.70753 32.5201Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M-11.6241 27.1061C-11.5121 34.7898 -9.1118 43.2095 -7.92564 46.4589C-11.1671 39.7488 -14.0601 37.2479 -18.0813 32.199C-21.2981 28.1599 -22.8478 24.5296 -23.3138 23.2531L-23.5953 21.9755C-23.4662 16.2539 -19.6499 15.426 -17.7578 15.7273C-15.7599 16.3187 -11.736 19.4223 -11.6241 27.1061Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M75.7419 397.906C81.696 389.456 82.7119 382.549 82.4755 380.152C83.7645 383.34 87.7885 390.614 93.5728 394.209C99.3572 397.804 103.727 404.867 105.374 407.844C106.304 410.376 105.315 415.09 101.454 415.367C97.5933 415.645 95.9884 412.047 95.6686 410.213C95.4949 408.678 94.7941 404.854 93.3806 401.836C91.9672 398.818 89.5339 395.118 88.4939 393.646C87.1662 391.637 84.1037 386.126 82.4755 380.152C83.372 386.327 81.3747 394.963 80.2639 398.509C79.8979 399.464 78.957 402.094 78.1215 404.976C77.286 407.859 77.6721 411.632 77.9695 413.158C78.0687 415.379 77.2621 419.856 73.2419 419.997C69.2217 420.138 68.1241 415.475 68.0779 413.127C68.1516 411.574 69.7878 406.356 75.7419 397.906Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M81.8743 405.263C83.8726 397.841 83.8712 389.089 83.6207 385.641C84.9 392.976 86.9978 396.167 89.4825 402.116C91.4703 406.876 91.9662 410.789 92.0646 412.143L91.9852 413.449C90.2928 418.919 86.3942 418.679 84.6565 417.876C82.8964 416.764 79.8759 412.686 81.8743 405.263Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M44.6239 22.1309C38.7933 30.6658 37.8779 37.5861 38.1491 39.9794C36.8139 36.8106 32.6846 29.5951 26.8486 26.0841C21.0126 22.5731 16.5408 15.5732 14.851 12.6209C13.8838 10.1019 14.8038 5.37481 18.6603 5.04144C22.5169 4.70808 24.1739 8.28288 24.5204 10.1119C24.7164 11.6442 25.4727 15.4579 26.9299 18.4551C28.3871 21.4523 30.8739 25.1165 31.9352 26.5739C33.2919 28.5636 36.4342 34.0301 38.1491 39.9794C37.163 33.8184 39.0345 25.1547 40.0936 21.593C40.4457 20.633 41.3483 17.9896 42.1418 15.0953C42.9352 12.201 42.4944 8.43431 42.1748 6.91276C42.0433 4.6933 42.7848 0.204748 46.8025 0.00616782C50.8202 -0.192412 51.9855 4.45356 52.0659 6.80136C52.0147 8.35497 50.4546 13.5959 44.6239 22.1309Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(193 42)",
    d: "M38.3852 14.8623C36.495 22.313 36.6237 31.0641 36.9243 34.5082C35.5385 27.192 33.3945 24.0311 30.8235 18.1186C28.7667 13.3886 28.2141 9.48282 28.0959 8.12975L28.1563 6.82322C29.7691 1.32985 33.6707 1.51311 35.4199 2.29141C37.1959 3.37723 40.2755 7.41156 38.3852 14.8623Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_218_14601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0244 210) rotate(90) scale(210 211.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCkdHomeDesign2);
export default __webpack_public_path__ + "static/media/ckd-home-design-2.f0de419fa085af531ff10001702176c3.svg";
export { ForwardRef as ReactComponent };